// 匈牙利语
import huLocale from 'element-ui/lib/locale/lang/hu'


const hu = {
  // ============== 登陆页 start=============
  "登录": "Bejelentkezés",
  "退出": "Kijelentkezés",
  "账号": "Fiók",
  "密码": "Jelszó",
  "验证码": "Ellenőrző kód",
  "请输入账号": "Kérjük, adja meg fiókját",
  "请输入密码": "Kérjük, adja meg jelszavát",
  "请输入验证码": "Kérjük, adja meg az ellenőrző kódot",
  "验证码不正确": "Helytelen ellenőrző kód",
  "没有账号": "Nincs fiók",
  "请": "Kérjük",
  "点击注册": "Kattintson a regisztrációhoz",
  // ============== 登陆页 end  =============
  // =========== 首页 start==================
  "门店总量": "Összes bolt",
  "用户总量": "Összes felhasználó száma",
  "营业总量": "Teljes üzleti forgalom",
  "订单总量": "Összes rendelés mennyisége",
  "商品总量": "Teljes készletmennyiség",
  "销售总额": "Teljes értékesítés",
  "元": "€",
  "预计收入": "Várható bevétel",
  "今日概况": "A mai összefoglaló",
  "销售额": "Értékesítési összeg",
  "支付订单数": "Fizetett rendelések",
  "昨日": "Tegnap",
  "新增用户数": "Új felhasználók",
  "新增商户": "Új kereskedők",
  "下单用户数": "Rendelést leadó felhasználók",
  "待办事项": "Függőben lévő feladatok",
  "请尽快处理，以免影响营业": "Kérjük, kezelje sürgősen, hogy ne befolyásolja az üzlet menetét",
  "待处理订单": "Feldolgozás alatt álló rendelések",
  "库存告急": "Készletválság",
  "销量": "Eladási mennyiség",
  "暂无上榜记录": "Jelenleg nincsenek rangsorolt bejegyzések",
  "成交额": "Tranzakciós mennyiség",
  "成交量": "Tranzakciós rendelések",
  "退单额": "Visszatérítés összege",
  "退单量": "Visszatérítési rendelések",
  // =========== 首页 end==================
  // =========== 建店必做 start=============
  "基本资料": "Alapinformáció",
  "编辑门店": "Áruház szerkesztése",
  "官方网站": "Hivatalos honlap",
  "门店服务": "Áruházi szolgáltatások",
  "服务与营业时间": "Szolgáltatások és nyitvatartási idő",
  "桌码管理": "Asztal kód kezelése",
  "收银台": "Pénztár",
  "后厨": "Konyha",
  "商品": "Termékek",
  "商品分类": "Árucikkek osztályozása",
  "添加商品": "Termék hozzáadása",
  "网站": "Weboldal",
  "网站编辑": "Weboldal szerkesztése",
  "上一步": "Előző lépés",
  "保存": "Mentés",
  "下一步": "Következő lépés",
  "提交失败": "A beküldés sikertelen",
  "获取当前进度信息失败": "Nem sikerült beszerezni az aktuális haladási információkat",
  "请输入门店名称": "Kérjük, adja meg az áruház nevét",
  "登录密码": "Bejelentkezési jelszó",
  "请输入登录密码": "Kérjük, adja meg a bejelentkezési jelszót",
  "确认密码": "Jelszó megerősítése",
  "请输入确认密码": "Kérjük, erősítse meg a jelszót",
  "联系人": "Kapcsolattartó",
  "请输入联系人": "Kérjük, adja meg a kapcsolattartó nevét",
  "请输入联系电话": "Kérjük, adja meg a kapcsolattartó telefonszámát",
  "店铺类型": "Áruház típusa",
  "分店": "Fiók",
  "直营": "Közvetlen értékesítés",
  "同步主店": "Szinkronizálás a fő áruházzal",
  "分店创建": "Fiók létrehozása",
  "温馨提示：选择后，请勿随意修改，以免造成门店商品数据错乱": "Megjegyzés: Kérem, ne módosítsa véletlenszerűen a kiválasztott elemeket, hogy elkerülje az áruház áruk adatainak zavarát",
  "绑定用户": "Felhasználó hozzárendelése",
  "选择用户": "Felhasználó kiválasztása",
  "用户昵称": "Becenév",
  "选择图片": "Kép kiválasztása",
  "地址": "Cím",
  "请输入地址": "Kérjük, adja meg a címet",
  "门店坐标": "Áruház koordináták",
  "商家介绍": "Kereskedő bemutatása",
  "状态": "Állapot",
  "开启": "Nyitva",
  "禁止": "Zárva",
  "营业状态": "Nyitvatartási állapot",
  "营业中": "Nyitva",
  "停止营业": "Zárva",
  "上传图片": "Kép feltöltése",
  "获取当前门店失败，请刷新界面重试": "Nem sikerült beszerezni az aktuális áruházat, frissítse az oldalt, és próbálja újra",
  "商城名称": "Áruház neve",
  "商城名称不能为空": "Az áruház neve nem lehet üres",
  "访问网址后缀": "Webhely utótag",
  "访问网址": "Webhely látogatás",
  "手机网站": "Mobil weboldal",
  "默认": "Alapértelmezett",
  "自定义": "Egyéni",
  "Pad点餐网站": "Pad rendelési weboldal",
  "收银台网站": "Pénztár webhely",
  "后厨网站": "Konyhai weboldal",
  "会员设置": "Tag-beállítások",
  "请选择默认头像": "Kérjük, válassza ki az alapértelmezett profilképet",
  "门店二维码": "Áruház QR-kódja",
  "下载": "Letöltés",
  "营业时间": "Nyitvatartási idő",
  "店内营业时间": "Áruházi nyitvatartási idő",
  "请选择店内营业时间": "Kérjük, válassza ki az áruházi nyitvatartási időt",
  "开始时间": "Kezdési idő",
  "结束时间": "Vége",
  "选择时间范围": "Válassza ki az időintervallumot",
  "自提营业时间": "Saját átvételi nyitvatartás",
  "请选择自提营业时间": "Kérjük, válassza ki a saját átvételi nyitvatartási időt",
  "外卖营业时间": "Házhozszállítási nyitvatartás",
  "请选择外卖营业时间": "Kérjük, válassza ki a házhozszállítási nyitvatartást",
  "外卖配送": "Házhozszállítás",
  "注": "Megjegyzés",
  "外卖配送方式至少选择一个": "Legalább egy házhozszállítási módot válasszon",
  "店内配置": "Áruházi beállítás",
  "店内用餐方式至少选择一个": "Legalább egy asztalozási módszert válasszon",
  "堂食服务": "Asztalozási szolgáltatás",
  "店内堂食结算模式": "Asztalozási elszámolási mód",
  "先结账后用餐": "Először fizet, majd étkezik",
  "先用餐后结账": "Először étkezik, majd fizet",
  "收银台桌台清台设置": "Pénztár asztal törlés beállítások",
  "定时清台": "Időzített asztaltörlés",
  "立即清台": "Azonnali asztaltörlés",
  "开启定时清台后，系统将在设置的时间后自动清除收银台点餐的桌台，此功能仅在餐前付款模式下生效": "Az időzített asztaltörlés bekapcsolása után a rendszer automatikusan törli a pultot a beállított idő után, ez a funkció csak az étkezés előtti fizetési módban működik",
  "桌台订单清台设置": "Asztaltörlés beállítás",
  "分钟后自动清理桌台（扫桌码点餐和收银桌台点餐定时清台时间）": "Perc múlva automatikusan tisztítja az asztalt (időzített asztaltörlés a pultkódos rendelés és a pénztár pultasztalon való rendelés esetén)",
  "店内堂食服务费": "Asztalozási szolgáltatási díj",
  "按就餐人数收取": "Fizetés az étkezők számától függően",
  "按每桌台收取": "Minden asztal díja",
  "请输入服务费": "Kérjük, adja meg a szolgáltatási díjat",
  "位": "Személy",
  "桌": "Asztal",
  "店内包装费类型": "Csomagolási díj típusa",
  "按商品收费": "Árucikk alapján számított díj",
  "按单收费": "Rendelés alapján számított díj",
  "包装费": "Csomagolási díj",
  "请输入包装费": "Kérjük, adja meg a csomagolási díjat",
  "外卖服务": "Házhozszállító szolgáltatás",
  "外卖包装费类型": "Házhozszállító csomagolási díj típusa",
  "外卖配送范围": "Házhozszállítás területe",
  "请输入外卖配送范围": "Kérjük, adja meg a házhozszállítási területet",
  "外卖配送费": "Házhozszállítási díj",
  "请输入外卖配送费": "Kérjük, adja meg a házhozszállítási díjat",
  "最低消费": "Minimális vásárlási összeg",
  "请输入最低消费": "Kérjük, adja meg a minimális vásárlási összeget",
  "添加类型": "Típus hozzáadása",
  "类型名称": "Típus neve",
  "删除": "Törlés",
  "桌位管理": "Asztalkezelés",
  "最少人数": "Minimális személyek száma",
  "最多人数": "Maximális személyek száma",
  "取 消": "Mégse",
  "确 定": "Megerősít",
  "请输入类型名称": "Kérjük, adja meg a típus nevét",
  "排序不能为空": "A rendezés mező nem lehet üres",
  "排序必须为数字": "A rendezésnek számnak kell lennie",
  "添加成功": "Sikeres hozzáadás",
  "修改类型": "Típus módosítása",
  "修改成功": "Sikeres módosítás",
  "添加区域": "Terület hozzáadása",
  "区域名称": "Terület neve",
  "修改区域": "Terület módosítása",
  "请输入区域名称": "Kérjük, adja meg a terület nevét",
  "分类名称": "Kategória neve",
  "编号": "Száma",
  "选择区域": "Terület kiválasztása",
  "请选择": "Kérjük, válasszon",
  "选择类型": "Típus kiválasztása",
  "查询": "Keresés",
  "桌号id": "Asztalazonosító",
  "所属区域": "Tartozó terület",
  "桌位类型": "Asztaltípus",
  "桌位编码": "Asztalkód",
  "人数区间": "Személyek száma intervallum",
  "人": "Emberek",
  "二维码": "QR-kód",
  "桌位编号": "Asztal száma",
  "请输入桌位编号": "Kérjük, adja meg az asztal számát",
  "请选择类型名称": "Kérjük, válassza ki a típus nevét",
  "请选择所属区域": "Kérjük, válasszon tartozási területet",
  "添加桌位": "Asztal hozzáadása",
  "关键词": "Kulcsszó",
  "添加收银员": "Pénztáros hozzáadása",
  "姓名": "Név",
  "登录账号": "Bejelentkezési fiók",
  "联系方式": "Kapcsolat módja",
  "收银员管理": "Pénztáros kezelés",
  "编辑": "Szerkesztés",
  "手机号": "Mobilszám",
  "请输入登录账号": "Kérjük, adja meg a bejelentkezési fiókot",
  "长度在6到16个字符": "A karakterek számának 6-tól 16-ig kell lennie",
  "两次输入密码不一致！": "A két jelszó nem egyezik meg!",
  "禁用": "Letiltás",
  "删除后不可恢复，确认删除该记录吗?": "A törlés után nem lehet visszaállítani, megerősíti a bejegyzés törlését?",
  "提示": "Tipp",
  "后厨人员管理": "Konyhai személyzet kezelése",
  "添加后厨人员": "Konyhai személyzet hozzáadása",
  "添加后厨账号": "Konyha fiók hozzáadása",
  "普通分类": "Általános kategória",
  "添加分类": "Kategória hozzáadása",
  "图片": "Kép",
  "分类排序": "Kategória rendezése",
  "税率设置": "Adókulcs beállítás",
  "添加税率": "Adókulcs hozzáadása",
  "税率分类名称": "Adókulcs kategória neve",
  "税率": "Adókulcs",
  "适用于菜品分类": "Ételekhez alkalmazható osztályozás",
  "未找到相应数据": "Nincs megfelelő adat",
  "请输入分类名称": "Kérjük, adja meg a kategórianév",
  "分类排序不能为空": "A kategória rendezése nem lehet üres",
  "分类排序必须为数字": "A kategória rendezése számnak kell lennie",
  "正在翻译，请稍后": "Fordítás folyamatban, kérjük, várjon",
  "多语言翻译": "Többnyelvű fordítás",
  "修改分类": "Kategória módosítása",
  "翻译": "Fordítás",
  "分类图片": "Kategória képe",
  "外卖商品": "Házhozszállító termékek",
  "店内商品": "Áruházi termékek",
  "商品管理": "Termékmenedzsment",
  "分类管理": "Kategóriakezelés",
  "上架中": "Eladás alatt",
  "下架": "Levétel",
  "商品名称": "Termék neve",
  "请输入商品名称": "Kérjük, adja meg a termék nevét",
  "添加产品": "Termék hozzáadása",
  "产品": "Termék",
  "实际销量": "Tényleges értékesítés",
  "库存": "Készlet",
  "发布时间": "Kiadás ideje",
  "销售价": "Értékesítési ár",
  "下架中": "Levétel alatt",
  "强制下架": "Kényszerű levétel",
  "重新上架": "Az eladás újraindítása",
  "上架": "Feltöltés",
  "确认要": "Megerősítés",
  "成功": "Siker",
  "删除成功": "Sikeres törlés",
  "请先选择一个选项": "Kérem, előbb válasszon egy lehetőséget",
  "正在完成翻译，请稍后操作": "Fordítás folyamatban, kérjük, később próbálja újra",
  "请检查表单的必填项是否全部填写": "Kérjük, ellenőrizze, hogy az űrlap összes kötelező mezője kitöltve van-e",
  "补全成功": "Sikeres kiegészítés",
  "主语言选择": "Fő nyelv kiválasztása",
  "请选择主语言": "Kérem, válassza ki a fő nyelvet",
  "高级设置": "Speciális beállítások",
  "取消": "Mégse",
  "修改": "Módosítás",
  "保存成功": "Mentés sikeres",
  "规格": "Specifikáció",
  "库存计算方式": "Raktárkészlet számítási módszer",
  "下单减库存": "Rendelés a raktárkészlet csökkentése érdekében",
  "特色分类": "Kiemelt osztályozás",
  "产品规格": "Termékspecifikáció",
  "单规格": "Egyszeres specifikáció",
  "多规格": "Több specifikáció",
  "此商品正在参加活动，不能修改规格": "Ez a termék részt vesz egy eseményen, nem lehet módosítani a specifikációt",
  "AI魔法创建": "AI varázslat létrehozása",
  "通过人工智能技术，可以根据商品名称自动填写商品详细信息，如配料、卖点、口味等。": "Az AI technológiának köszönhetően automatikusan kitöltheti a részletes információkat a termék neve alapján, például összetevők, eladási pontok, ízek stb.",
  "所属分类": "Tartozó kategória",
  "请选择商品分类": "Kérem, válasszon termékkategóriát",
  "请填写商品详情": "Kérjük, töltse ki a termékinformációkat",
  "商品详情": "Termékinformáció",
  "换一换": "Cserélni",
  "产品价格": "Termék ár",
  "请填写产品价格": "Kérem, adja meg a termék árát",
  "请填写包装费": "Kérem, adja meg a csomagolási díjat",
  "规格明细": "Specifikációs részletek",
  "规格名称": "Specifikáció neve",
  "请输入内容": "Kérjük, írja be a tartalmat",
  "价格": "Ár",
  "添加规格": "Specifikáció hozzáadása",
  "商品图片": "Termékkép",
  "请上传商品图片": "Kérem, töltse fel a termékképet",
  "从AI图库中选择": "Válasszon az AI képarchívumból",
  "使用中文从AI图库搜索": "Keresés az AI képarchívumban kínai nyelven",
  "AI图库": "AI képarchívum",
  "确认使用": "Megerősítés",
  "AI未识别到您的商品图片": "Az AI nem ismerte fel a termékképét",
  "可在搜索框": "Elérhető a keresőmezőben",
  "更换菜品名称": "Étel nevének megváltoztatása",
  "请输入菜品名称！": "Kérem, írja be az étel nevét!",
  "请在主语言界面上进行操作": "Kérem, végezze a műveletet a fő nyelvi felületen",
  "本商品正在参加活动，不能删除规格！": "Ez a termék részt vesz egy eseményen, nem lehet törölni a specifikációt!",
  "不能再删除了": "Nem lehet többé törölni",
  "多语言": "Többnyelvű",
  "商品加料": "Termék hozzávalók",
  "添加加料": "Hozzávaló hozzáadása",
  "加料名称": "Hozzávaló neve",
  "如:杯型": "Például: Pohár típus",
  "内容": "Tartalom",
  "积分设置": "Pontbeállítás",
  "是否开启积分赠送": "Pontajándék adás engedélyezése",
  "其他设置": "Egyéb beállítások",
  "商品状态": "Termékállapot",
  "选择商品状态": "Válassza ki a termék állapotát",
  "初始销量": "Kezdeti eladás",
  "商品排序": "Termék rendezés",
  "限购数量": "Vásárlási korlátozás mennyisége",
  "每个会员购买的最大数量，0为不限购": "A tagok által vásárolható maximális mennyiség, 0 jelöli a korlátlan mennyiséget",
  "会员折扣设置": "Tagszövetkezeti kedvezmény beállítása",
  "是否开启会员折扣": "Tagszövetkezeti kedvezmény engedélyezése",
  "默认折扣": "Alapértelmezett kedvezmény",
  "单独设置折扣": "Kedvezmény külön beállítása",
  "默认折扣：默认为用户所属会员等级的折扣率": "Alapértelmezett kedvezmény: az alapértelmezett a felhasználó tagsági szintjének kedvezményrátája",
  "折扣佣金类型": "Kedvezmény jutalék típus",
  "百分比": "Százalék",
  "固定金额": "Fix összeg",
  "折扣": "Kedvezmény",
  "请输入折扣": "Kérem, írja be a kedvezményt",
  "分销设置": "Terjesztés beállítása",
  "是否开启分销": "Terjesztés engedélyezése",
  "分销规则": "Terjesztés szabály",
  "平台规则": "Platform szabály",
  "单独规则": "Külön szabály",
  "平台规则：层级": "Platform szabály: Szint",
  "1级佣金": "1. szint jutalék",
  "2级佣金": "2. szint jutalék",
  "3级佣金": "3. szint jutalék",
  "分销佣金类型": "Terjesztés jutalék típus",
  "单独分销设置": "Külön terjesztés beállítás",
  "一级佣金": "1. szint jutalék",
  "二级佣金": "2. szint jutalék",
  "三级佣金": "3. szint jutalék",
  "请填写商品名称": "Kérem, adja meg a termék nevét",
  "你选择商品分类": "Ön választott termékkategóriát",
  "商品卖点": "Termék eladási pontja",
  "配料": "Hozzávalók",
  "添加项": "Elem hozzáadása",
  "删除项": "Elem törlése",
  "审核状态": "Ellenőrzési állapot",
  "选择审核状态": "Válassza ki az ellenőrzési állapotot",
  "通过": "Elfogad",
  "未通过": "Nem fogad el",
  "审核备注": "Ellenőrzés megjegyzése",
  "请输入拒绝原因": "Kérem, adja meg az elutasítás okát",
  "商品属性": "Termékjellemzők",
  "添加属性": "Tulajdonság hozzáadása",
  "属性名称": "Tulajdonság név",
  "属性值": "Tulajdonság érték",
  "至少填写两个": "Legalább két mező kitöltése kötelező",
  "如:温度": "Például: Hőmérséklet",
  "口味": "Íz",
  "商品同步": "Termék szinkronizálás",
  "同步至外卖": "Szinkronizálás a kiszállítással",
  "库存数量": "Raktárkészlet mennyisége",
  "请填写库存数量": "Kérem, adja meg a raktárkészlet mennyiségét",
  "请上传分类图片": "Kérem, töltse fel a kategóriaképet",
  "发布": "Közzététel",
  "级": "Szint",
  "请填写口味": "Kérem, adja meg az ízt",
  "从AI图库搜索": "Keresés az AI képarchívumban",
  "AI获取标签": "AI címkék",
  "标签": "Címke",
  "添加的标签可以帮助AI点餐助手更准确地理解顾客的点餐需求": "A hozzáadott címkék segíthetik az AI rendelési asszisztenst a vásárlók rendelési igényeinek pontosabb megértésében",
  "同步至店内": "Szinkronizálás az üzletbe",
  "是否同步商品至外卖": "Szeretné szinkronizálni a termékeket a kiszállítással?",
  "是否同步商品至店内": "Szeretné szinkronizálni a termékeket az üzletbe?",
  "付款减库存": "Fizetés a raktárkészlet csökkentése érdekében",
  "菜品录入使用语言": "Ételbevitel nyelve",
  "网站主页": "Weboldal főoldal",
  "主题编辑": "Téma szerkesztése",
  "我的菜单": "Saját menü",
  "添加菜单": "Menü hozzáadása",
  "菜单名称": "Menü neve",
  "图标": "Ikon",
  "是否显示": "Megjelenítés",
  "添加时间": "Hozzáadás időpontja",
  "更新时间": "Frissítés időpontja",
  "操作": "Művelet",
  "正在处理": "Feldolgozás alatt",
  "处理失败，请重试": "A feldolgozás sikertelen, próbálja újra",
  "此操作将永久删除该记录, 是否继续?": "Ezzel az intézkedéssel véglegesen törli ezt a bejegyzést, folytatja?",
  "确定": "Megerősít",
  "主题选择": "Téma kiválasztása",
  "主题一": "Első téma",
  "主题二": "Második téma",
  "主题三": "Harmadik téma",
  "主题四": "Negyedik téma",
  "主题五": "Ötödik téma",
  "主题六": "Hatodik téma",
  "主页预览": "Főoldal előnézet",
  "撤回": "Visszavonás",
  "获取预览网站失败,请检查网络或联系管理员": "Nem sikerült az előnézeti webhely elérése, ellenőrizze a hálózatot vagy lépjen kapcsolatba az adminisztrátorral",
  "撤回成功": "Visszavonás sikeres",
  "编辑菜单": "Menü szerkesztése",
  "请输入广告标题": "Kérem, adja meg a hirdetés címét",
  "图标大小为": "Ikon mérete",
  "显示": "Megjelenítés",
  "隐藏": "Elrejtés",
  "请输入数字": "Kérem, adjon meg egy számot",
  "链接": "Hivatkozás",
  "选择链接": "Hivatkozás kiválasztása",
  "提交": "Beküldés",
  "请输入菜单名称": "Kérem, írja be a menü nevét",
  "链接到": "Hivatkozás erre",
  "请上传图标": "Kérem, töltse fel az ikont",
  "确定要删除吗?": "Biztosan törölni szeretné?",
  "次浏览": "Megtekintés",
  "每日必拼": "Napi kötelező kiválasztás",
  "更多": "További",
  "2人团": "2 személyes csapat",
  "去开团": "Csapat indítása",
  "活动砍价": "Akciós árengedmény",
  "已抢2件": "Már 2 darabot elvitt",
  "立即砍价": "Azonnali árengedmény",
  "满": "Teljes",
  "可用": "Elérhető",
  "立即领取": "Azonnali igénylés",
  "热门直播": "Népszerű élő adás",
  "已售": "Eladott",
  "限时秒杀": "Korlátozott idejű akció",
  "搜索商品": "Termék keresése",
  "线下门店": "Helyszíni üzlet",
  "门店logo": "Üzlet logója",
  "门店地址": "Üzlet címe",
  "联系电话": "Kapcsolattartó telefonszáma",
  "您的浏览器不支持 video 标签": "Az Ön böngészője nem támogatja a video címkét",
  "店家正在直播、折扣套餐秒杀中": "Az üzlet tulajdonosa éppen élőben közvetít, és kedvezményes csomagokat kínál",
  "进入": "Belépés",
  "至少保留一个": "Legalább egy elemet tartsa meg",
  "咨询分类": "Konzultációs kategória",
  "全部分类": "Az összes kategória",
  "显示数量": "Megjelenített elemek száma",
  "咨询数据请到": "Információkért kérjük, látogasson el ide:",
  "中管理": "Központi vezérlés",
  "插件": "Kiegészítő",
  "资讯": "Információ",
  "显示类型": "Megjelenítés típusa",
  "有图模式": "Képes mód",
  "无图模式": "Kép nélküli mód",
  "组件样式": "Komponens stílus",
  "显示内容": "Tartalom megjelenítése",
  "拼团价格": "Csapatár",
  "划线价格": "Árcsökkentés",
  "指示点颜色": "Jelzőpont színe",
  "重置": "Visszaállítás",
  "切换时间": "Időváltás",
  "轮播图自动切换的间隔时间，单位：毫秒": "A karusell kép automatikus váltásának időköze, egység: ezredmásodperc",
  "链接地址": "Hivatkozás címe",
  "请选择链接地址": "Kérem, válassza ki a hivatkozás címét",
  "添加一个": "Egy hozzáadása",
  "标题内容": "Cím tartalma",
  "文字内容": "Szöveges tartalom",
  "链接名称": "Hivatkozás Neve",
  "正在砍价": "Árut Bargaining",
  "商品原价": "Áru Eredeti Ára",
  "背景颜色": "Háttérszín",
  "组件高度": "Komponens Magassága",
  "上下边距": "Felső és Alsó Margó",
  "线条样式": "Vonal Stílusa",
  "实线": "Egyszerű Vonal",
  "虚线": "Szaggatott Vonal",
  "点状": "Pöttyös",
  "线条颜色": "Vonal Színe",
  "线条高度": "Vonal Magassága",
  "左右边距": "Bal és Jobb Margó",
  "标题": "Cím",
  "颜色": "Szín",
  "每行数量": "Darabok Száma Soronként",
  "1个": "1 Darab",
  "2个": "2 Darab",
  "文字颜色": "Szöveg Színe",
  "公告图标": "Bejelentés Ikon",
  "公告内容": "Bejelentés Tartalom",
  "商品来源": "Termék Forrása",
  "自动获取": "Automatikus Elérés",
  "手动选择": "Kézi Kiválasztás",
  "综合": "Összetett",
  "商品列表": "Termék Lista",
  "选择产品": "Termék Választás",
  "列表平铺": "Lista Elrendezés",
  "横向滑动": "Vízszintes Görgetés",
  "分列数量": "Oszlopok Száma",
  "单列": "Egy Oszlop",
  "两列": "Két Oszlop",
  "三列": "Három Oszlop",
  "商品价格": "Termék Ár",
  "商品销量": "Termék Eladások",
  "提示文字": "Tipp Szöveg",
  "搜索框样式": "Keresődoboz Stílusa",
  "方形": "Négyzet alakú",
  "圆角": "Kerekített Sarok",
  "圆弧": "Ív",
  "文字对齐": "Szöveg Igazítás",
  "居左": "Bal",
  "居中": "Középen",
  "居右": "Jobb",
  "秒杀价格": "Másodperces Ár",
  "底边距": "Alsó Margó",
  "右边距": "Jobb Margó",
  "不透明度": "Átlátszatlanság",
  "客服类型": "Ügyfélszolgálat Típusa",
  "在线聊天": "Online Beszélgetés",
  "拨打电话": "Hívás",
  "电话号码": "Telefonszám",
  "客服图标": "Ügyfélszolgálat Ikon",
  "标题类型": "Cím Típusa",
  "页面名称": "Oldal Neve",
  "页面名称仅用于后台查找": "Oldal Neve Csak Háttérkeresésre használandó",
  "分享标题": "Megosztás Címe",
  "小程序端转发时显示的标题": "A Mini Program Által Továbbított Cím",
  "文章数据请到": "Cikk Adat Kérjük Menjen a",
  "内容管理": "Tartalom Kezelés",
  "文章列表": "Cikk Lista",
  "单行": "Egyszerű sor",
  "两行": "Két sor",
  "门店列表": "Áruház Lista",
  "选择门店": "Áruház Kiválasztás",
  "展示数量": "Kijelenített Darabok Száma",
  "视频高度": "Videó Magassága",
  "滑块可用左右方向键精确调整": "A Csúszka Pontosan Átállítható Balra és Jobbra Mutató Nyilakkal",
  "视频封面": "Videó Borító",
  "视频地址": "Videó Cím",
  "自动播放": "Automatikus Lejátszás",
  "布局方式": "Elrendezés Módja",
  "堆积两列": "Két Oszlopos Elrendezés",
  "堆积三列": "Három Oszlopos Elrendezés",
  "堆积四列": "Négy Oszlopos Elrendezés",
  "橱窗样式": "Kirakat Stílus",
  "橱窗样式最多显示四张图片，超出隐藏": "A Kirakat Modell Legfeljebb Négy Képet Jelenít Meg, Túlmutató Elrejtés",
  "请确保所有图片的尺寸/比例相同": "Kérjük, Biztosítsa, Hogy Minden Kép Ugyanolyan Méretű / Arányú",
  "标题文字": "Cím Szöveg",
  "组件库": "Komponens Könyvtár",
  "媒体组件": "Média Komponens",
  "商城组件": "Bevásárlási Központ Komponens",
  "工具组件": "Eszköz Komponens",
  "登录组件": "Bejelentkezési Komponens",
  "资讯管理": "Információ Kezelés",
  "添加资讯": "Információ Hozzáadása",
  "资讯ID": "Információ Azonosító",
  "封面": "Borító",
  "资讯标题": "Információ Cím",
  "资讯分类": "Információ Kategória",
  "虚拟阅读量": "Virtuális Olvasási Mennyiség",
  "实际阅读量": "Tényleges Olvasási Mennyiség",
  "资讯排序": "Információ Rendezés",
  "已取消删除": "Törlés Mégse",
  "请输入文章标题": "Kérem Adja Meg a Cikk Címét",
  "描述": "Leírás",
  "请输入文章描述": "Kérem, Adja Meg a Cikk Leírását",
  "缩略图": "Kicsinyítés",
  "资讯状态": "Információ Állapota",
  "资讯内容": "Információ Tartalom",
  "分类ID": "Kategória ID",
  "编辑分类": "Kategória Szerkesztése",
  "恭喜你，修改成功": "Gratulálok, Sikeres Módosítás",
  "编辑资讯": "Információ Szerkesztése",
  "份": "Darab",
  "中文": "Kínai",
  "英语": "Angol",
  "意大利语": "Olasz",
  "德语": "Német",
  "西班牙语": "Spanyol",
  "法语": "Francia",
  "克罗地亚": "Horvát",
  "斯洛文尼亚": "Szlovén",
  "匈牙利语": "Magyar",
  "规格库": "Specifikáció Könyvtár",
  "属性库": "Tulajdonság Könyvtár",
  "加料库": "Hozzávaló Könyvtár",
  "规格名": "Specifikáció Neve",
  "批量删除": "Tömeges Törlés",
  "请输入规格名称": "Kérem, Adja Meg a Specifikáció Nevet",
  "删除后不可恢复，确认删除吗?": "Törlés utána már nem lehet visszaállítani, megerősíti a törlést?",
  "属性名": "Tulajdonság Neve",
  "请输入属性名称": "Kérem, Adja Meg a Tulajdonság Nevet",
  "请输入属性值": "Kérem, Adja Meg a Tulajdonság Értékét",
  "添加属性名": "Tulajdonság Név Hozzáadása",
  // =========== 建店必做 end ==================

  // ================ 订单 start ================
  "实时概况": "Valós idejű áttekintés",
  "营业总额": "Teljes üzleti bevétel",
  "有效订单": "Érvényes megrendelések",
  "退款金额": "Visszatérítés összege",
  "销量排行榜": "Értékesítési rangsor",
  "销售额排行榜": "Értékesítési összeg rangsora",
  "商品排行榜": "Termék rangsor",
  "订单号": "Rendelésszám",
  "请输入订单号": "Kérjük, adja meg a rendelésszámot",
  "起始时间": "Kezdés időpontja",
  "至": "Eddig",
  "开始日期": "Kezdés dátuma",
  "结束日期": "Befejezés dátuma",
  "导出": "Exportálás",
  "全部订单": "Az összes rendelés",
  "未付款": "Kifizetetlen",
  "进行中": "Folyamatban",
  "已完成": "Befejezett",
  "订单信息": "Rendelési információ",
  "下单时间": "Rendelés ideje",
  "取消申请中": "Lemondási kérelem folyamatban",
  "实付款": "Tényleges fizetés",
  "含服务费": "Szolgáltatási díjat tartalmaz",
  "含包装费": "Csomagolási díjat tartalmaz",
  "买家": "Vásárló",
  "门店名称": "Bolt neve",
  "出餐状态": "Ételkészítés állapota",
  "准备中": "Előkészítés alatt",
  "出餐中": "Ételkészítés alatt",
  "待取餐": "Várakozás átvételre",
  "交易状态": "Tranzakciós állapot",
  "支付方式": "Fizetési mód",
  "配送方式": "Szállítási mód",
  "订单详情": "Rendelés részletei",
  "出餐": "Étel kiszolgálása",
  "退款": "Visszatérítés",
  "核销": "Ellenőrzés",
  "确定要出餐吗?": "Biztosan szeretné kiszolgálni az ételt?",
  "确定要核销吗?": "Biztosan szeretné ellenőrizni?",
  "恭喜你，操作成功": "Gratulálok, sikeres művelet",
  "已取消核销": "Ellenőrzés visszavonva",
  "基本信息": "Alapinformáció",
  "订单来源": "Rendelés forrása",
  "订单金额": "Rendelés összege",
  "配送费": "Szállítási díj",
  "服务费": "Szolgáltatási díj",
  "优惠券抵扣": "Kupon levonás",
  "积分抵扣": "Pontok levonása",
  "满减金额": "Kedvezmény összege",
  "优惠金额": "Kedvezmény összege",
  "实付款金额": "Tényleges fizetés összege",
  "用餐方式": "Étkezés módja",
  "取餐时间": "Átvételi idő",
  "桌号": "Asztalszám",
  "修改价格": "Ár módosítása",
  "门店信息": "Bolt információ",
  "商品信息": "Termék információ",
  "会员折扣价": "Tagsági kedvezményes ár",
  "购买数量": "Vásárolt mennyiség",
  "商品总价": "Összes termék ára",
  "收货信息": "Szállítási információ",
  "收货人": "Felvevő",
  "收货电话": "Felvevő telefonszáma",
  "收货地址": "Szállítási cím",
  "备注": "Megjegyzés",
  "自提用户信息": "Személyes átvétel felhasználói információ",
  "用户信息": "Felhasználói információ",
  "联系手机": "Kapcsolattartási mobil",
  "付款信息": "Fizetési információ",
  "应付款金额": "Fizetendő összeg",
  "支付流水号": "Fizetési tranzakció szám",
  "付款状态": "Fizetés állapota",
  "付款时间": "Fizetés ideje",
  "发货信息": "Szállítási információ",
  "发货状态": "Szállítási állapot",
  "取消信息": "Lemondási információ",
  "商家备注": "Eladó megjegyzése",
  "门店自提核销": "Bolti személyes átvétel ellenőrzése",
  "核销员": "Ellenőrző alkalmazott",
  "核销状态": "Ellenőrzés állapota",
  "已核销": "Ellenőrzött",
  "核销时间": "Ellenőrzés ideje",
  "返回上一页": "Visszatérés az előző oldalra",
  "确认发货": "Szállítás megerősítése",
  "确认审核": "Ellenőrzés megerősítése",
  "请选择物流公司": "Kérem válassza ki a logisztikai céget",
  "请填写物流单号": "Kérem adja meg a szállítási számot",
  "恭喜你，发货成功": "Gratulálok, sikeres szállítás",
  "恭喜你，审核成功": "Gratulálok, sikeres ellenőrzés",
  "订单价格修改": "Rendelési ár módosítása",
  "运费金额": "Szállítási díj összege",
  "最终付款价": "Végleges fizetési ár",
  "取消订单": "Rendelés lemondása",
  "请输入备注": "Kérem adja meg a megjegyzést",
  "请输入退款金额": "Kérem adja meg a visszatérítés összegét",
  "确认退款?": "Visszatérítés megerősítése?",
  "已取消退款": "Visszatérítés visszavonva",
  "含配送费": "Szállítási díjat tartalmaz",
  "确认送达": "Kiszállítás megerősítése",
  "是否确认此操作?": "Megerősíti ezt a műveletet?",
  "配送状态": "Kiszállítás állapota",
  "备注信息": "Megjegyzés információ",
  "期望配送时间": "Várható szállítási idő",
  "订单状态": "Rendelés állapota",
  "骑手姓名": "Sofőr neve",
  "骑手电话": "Sofőr telefonszáma",
  "操作时间": "Művelet időpontja",
  "详情": "Részletek",
  "此操作将确认送达, 是否继续?": "Ez a művelet megerősíti a kiszállítást, folytatja?",
  "配送时间": "Kiszállítás időpontja",
  "配送信息": "Kiszállítási információ",
  "配送类型": "Szállítás típusa",
  "配送距离": "Szállítási távolság",
  "配送电话": "Szállítás telefonszáma",
  "配送费用": "Szállítási díj",
  "送达时间": "Kiszállítás ideje",
  "取消原因": "Lemondás oka",
  "请输入取消原因": "Kérem adja meg a lemondás okát",
  "米": "Méter",
  // ================ 订单 end  ================

  // ================= 门店 start ==============
  "门店ID": "Áruházazonosító",
  "联系地址": "Kapcsolatcím",
  "下载二维码": "Letöltés QR-kód",
  "H5网页": "H5 Weboldal",
  "添加门店": "Vállalkozás Terve",
  "设置": "Konfiguráció",
  "恭喜你，门店删除成功": "Gratulálok, Sikeres Áruháztörlés",
  "请输入地点": "Kérem Adja Meg a Helyet",
  "添加": "Vállalkozás",
  "等级": "Fokozat",
  "请选择会员等级": "Kérem Válasszon Tagsági Fokozatot",
  "性别": "Nem",
  "请选择性别": "Kérem Válasszon Nemet",
  "微信昵称": "WeChat Becenév",
  "请输入微信昵称": "Kérem Adja Meg a WeChat Becenévét",
  "微信头像": "WeChat Profilkép",
  "昵称": "Becenév",
  "用户余额": "Felhasználó Egyenlege",
  "累积消费金额": "Felhalmozott Fogyasztási Összeg",
  "注册时间": "Regisztrációs Idő",
  "分钟后自动清理桌台": "Asztalok Automatikus Tisztítása Perc Után",
  "扫桌码点餐和收银桌台点餐定时清台时间": "Asztalok Beolvasása Étkezéshez és Pénztári Asztalok Időzített Takarítási Ideje",
  "到店自提": "Átvétel a Boltban",
  "打包带走": "Elvitel",
  "店内就餐": "Helyben Fogyasztás",
  "外卖配送至少选择一种！": "Válasszon Legalább Egy Kiszállítási Módot Az Elviteleknél!",
  "店内配置至少选择一种！": "Válasszon Legalább Egy Belső Konfigurációt Az Üzletben!",
  "恭喜你，设置成功": "Gratulálok, Sikeres Konfiguráció",
  "恭喜你，门店修改成功": "Gratulálok, Sikeres Áruház Módosítás",
  "门店": "Áruház",
  "提现金额": "Kifizetés Összege",
  "打款方式": "Fizetési Mód",
  "待审核": "Várakozik Ellenőrzésre",
  "审核通过": "Elfogadva",
  "驳回": "Elutasítva",
  "原因": "Ok",
  "已打款": "Kifizetve",
  "审核": "Ellenőrzés",
  "确认打款": "Fizetés Megerősítése",
  "确认要打款吗?": "Fizetést Megerősíti?",
  "供应商名称": "Beszállító Neve",
  "余额变动场景": "Egyenlegváltozás Jelenete",
  "收入": "Bevétel",
  "提现": "Pénzfelvétel",
  "起始日期": "Kezdő Dátum",
  "变动金额": "Változás Összege",
  "描述/说明": "Leírás/Magyarázat",
  "创建时间": "Készítés Ideje",
  "恭喜你，门店添加成功": "Gratulálok, Sikeres Áruház Hozzáadás",
  "驳回原因": "Elutasítás Oka",
  "提现审核": "Pénzfelvétel Ellenőrzés",
  "小票打印设置": "Blokknyomtatási Beállítás",
  "是否开启商户小票打印": "Engedélyezi a Kereskedői Blokknyomtatást?",
  "选择打印机": "Válasszon Nyomtatót",
  "是否开启顾客小票打印": "Engedélyezi a Vevői Blokknyomtatást?",
  "选择打印机二": "Válasszon Nyomtatót Kettőt",
  "是否开启厨房小票打印": "Engedélyezi a Konyhai Blokknyomtatást?",
  "选择打印机三": "Válasszon Nyomtatót Hármat",
  "恭喜你，打印设置成功": "Gratulálok, Sikeres Nyomtatási Beállítás",
  "小票打印机列表": "Blokknyomtatási Nyomtatók Listája",
  "打印机ID": "Nyomtatóazonosító",
  "打印机名称": "Nyomtató Neve",
  "编辑小票打印机": "Blokknyomtatási Nyomtató Szerkesztése",
  "打印机类型": "Nyomtató Típus",
  "米泰打印机": "Mettai Nyomtató",
  "打印机编号": "Nyomtató Sorozatszáma",
  "打印机编号为9位数字，查看米泰打印机底部贴纸上面的编号": "A nyomtató sorozatszáma 9 jegyű szám, nézze meg a Mettai nyomtató alján lévő matricán",
  "打印机秘钥": "Nyomtató Kulcs",
  "打印联数": "Nyomtatási Példányszám",
  "同一订单，打印的次数": "Ugyanazon Rendelés Nyomtatási Mennyisége",
  "排序": "Rendezés",
  "数字越小越靠前": "Minél Kisebb a Szám, Annál Előrébb van",
  "新增小票打印机": "Új Blokknyomtatási Nyomtató Hozzáadása",
  "恭喜你，添加成功": "Gratulálok, Sikeres Hozzáadás",
  "配送方式设置": "Szállítási Mód Beállítása",
  "商家配送": "Kereskedői Szállítás",
  "自动配送时间(分钟)": "Automatikus Szállítási Idő (percek)",
  "设置0不自动配送，下单后未配送，设置时间后自動操作配送": "0 Beállítás esetén nincs automatikus szállítás. A rendelés leadása után szállítás nélkül, az idő beállítása után automatikus szállítás lesz kezdeményezve",
  "商户编号": "Kereskedői Azonosító",
  "门店编号": "Áruház Azonosító",
  "环境": "Környezet",
  "测试环境": "Teszt Környezet",
  "正式环境": "Éles Környezet",
  "回调地址": "Visszahívási Cím",
  "运营城市": "Üzemeltetési Város",
  "恭喜你，上传设置成功": "Gratulálok, Sikeres Feltöltés Beállítás",
  "菜品打印列表": "Étel Nyomtatási Lista",
  "名称": "Név",
  "打印类型": "Nyomtatási Típus",
  "外卖": "Elviteles",
  "店内": "Belül",
  "菜品打印": "Étel Nyomtatás",
  "是否开启": "Engedélyezés",
  "配送打印": "Szállítási Nyomtatás",
  "店内打印": "Belso Nyomtatás",
  "打印方式": "Nyomtatási Mód",
  "付款打印": "Fizetés Nyomtatás",
  "下单打印": "Rendelés Nyomtatás",
  "商品分组": "Termék Csoportosítás",
  "男": "Férfi",
  "女": "Nő",
  "未知": "Ismeretlen",
  "文件管理": "Fájlkezelés",
  "移动至": "Áthelyezés",
  "点击上传": "Kattintson a Feltöltéshez",
  "删除失败": "Törlés Sikertelen",
  "请选择文件": "Kérem Válasszon Fájlt",
  "确定移动选中的文件吗？, 是否继续?": "Biztos benne, hogy áthelyezi a kiválasztott fájlokat? Folytatja?",
  "只能上传图片！": "Csak képeket lehet feltölteni!",
  "上传文件只能是图片格式!": "A feltöltött fájl képformátumú kell legyen!",
  "上传文件大小不能超过 2MB!": "A fájl mérete nem lehet nagyobb 2 MB-nál!",
  "请查看/裁切其它上传图片!": "Kérem Tekintse/Módosítsa Más Feltöltött Képeket!",
  "图片上传中,请等待": "Kép Feltöltése, Kérem Várjon",
  "当前图片上传失败!": "Jelenlegi Kép Feltöltése Sikertelen!",
  "本次上传图片失败": "A Mostani Képfeltöltés Sikertelen",
  "本次最多只能上传1个文件": "Maximum 1 fájl tölthető fel egyszerre",
  "裁剪图片": "Kép Vágása",
  "选择优惠券": "Válasszon Kupont",
  "数量": "Mennyiség",
  "无限制": "Korlátlan",
  "请输入等级名称": "Kérem Adja Meg a Fokozat Nevet",
  "长度在3到5个字符": "A Hossz 3 és 5 Karakter Között Legyen",
  "错了哦，这是一条错误消息": "Hoppá, Ez Egy Hibás Üzenet",
  "增加税率": "Adókulcs Hozzáadása",
  "税率分类": "Adókulcs Kategória",
  "请输入税率分类": "Adja Meg Az Adókulcs Kategóriát",
  "自定义税率分类": "Egyedi Adókulcs Kategória",
  "请输入税率值": "Adja Meg az Adókulcs Értékét",
  "单位是": "Az Egység",
  "适用菜品分类": "Alkalmazható Étel Kategória",
  "请选择菜品分类": "Kérem Válasszon Étel Kategóriát",
  "修改税率信息": "Adókulcs Információ Módosítása",
  "分类名称不能为空": "A Kategórianév Nem Lehet Üres",
  // ================= 门店 end ==============
  // =====================  营销工具start ==========
  "会员管理": "Tagságkezelés",
  "等级管理": "Szintkezelés",
  "余额明细": "Egyenleg Részletek",
  "请输入昵称": "Kérem adja meg becenévét",
  "邮箱": "Email",
  "请输入邮箱地址": "Kérem adja meg az email címét",
  "会员等级": "Tagsági szint",
  "全部": "Mind",
  "无等级": "Nincs szint",
  "余额": "Egyenleg",
  "积分": "Pontok",
  "生日": "Születésnap",
  "充值": "Töltés",
  "恭喜你，用户删除成功": "Gratulálok, a felhasználó sikeresen törölve",
  "请选择等级": "Kérem válassza ki a szintet",
  "管理员备注": "Admin megjegyzések",
  "请输入管理员备注": "Kérem adjon meg admin megjegyzéseket",
  "恭喜你，用户修改成功": "Gratulálok, a felhasználó sikeresen módosítva",
  "会员充值": "Tagság feltöltés",
  "充值余额": "Töltés összege",
  "当前余额": "Jelenlegi egyenleg",
  "充值方式": "Töltés módja",
  "增加": "Növelés",
  "减少": "Csökkentés",
  "最终金额": "Végleges összeg",
  "变更金额": "Módosított összeg",
  "请输入变更金额": "Kérem adja meg a módosított összeget",
  "添加等级": "Szint hozzáadása",
  "等级名称": "Szint neve",
  "权重": "Súly",
  "升级条件": "Feljutás feltételei",
  "等级权重": "Szint súly",
  "请输入等级权重": "Kérem adja meg a szint súlyát",
  "权重越大，等级越高": "Minél nagyobb a súly, annál magasabb a szint",
  "等级折扣": "Szint kedvezmény",
  "请输入等级折扣": "Kérem adja meg a szint kedvezményét",
  "满足以下勾选的其中一个条件，会员自动升级到该等级": "Egyik alul pipált feltétel teljesítése esetén a tag automatikusan feljebb lép a szintjében",
  "累计消费满": "Kumulatív kiadás elérve",
  "编辑等级": "Szint szerkesztése",
  "累计积分满": "Kumulatív pontok elérve",
  "推荐人数满": "Ajánlott személyek száma elérve",
  "恭喜你，等级修改成功": "Gratulálok, a szint sikeresen módosítva",
  "个": "darab",
  "充值设置": "Töltés beállítások",
  "是否开启余额充值": "Egyenlegtöltés engedélyezése",
  "注：如开启则移动端显示充值按钮，如果小程序没有资质审核不过可不开启": "Megjegyzés: Ha engedélyezve van, a töltés gomb látható lesz a mobil eszközön; ha a mini program nem felel meg a minősítési vizsgálatnak, akkor maradhat letiltva",
  "是否开启自定义金额": "Egyedi összeg engedélyezése",
  "注：如开启则用户可以填写充值金额": "Megjegyzés: Ha engedélyezve van, a felhasználók egyedi összeget adhatnak meg",
  "最低充值金额": "Minimum összeg a feltöltéshez",
  "注：自定义充值金额最低充值多少€": "Megjegyzés: Milyen a minimum összeg az egyedi töltésnél?",
  "充值说明": "Töltési útmutató",
  "充值套餐": "Töltési csomagok",
  "支付金额": "Fizetési összeg",
  "到账数量": "Teljesített összeg",
  "充值时间": "Töltés ideje",
  "到账金额": "Tényleges összeg",
  "赠送金额": "Ajándék összeg",
  "提现设置": "Kifizetési beállítások",
  "是否开启提现": "Kifizetés engedélyezése",
  "注：如开启则移动端显示 egyenleg kifizetését": "Megjegyzés: Ha engedélyezve van, a mobil eszközön látható lesz a egyenleg kifizetés opció",
  "提现比例": "Kifizetési arány",
  "注：提现比例请填写数字0~100": "Megjegyzés: Kérem, írjon be egy számot 0 és 100 között a kifizetési arányhoz",
  "例：提现金额(100.00元) * 提现比例(100%) = 实际到账(100€)": "Példa: Kifizetés összege (100.00 CNY) * Kifizetési arány (100%) = Tényleges összeg (100€)",
  "最低提现金额": "Minimum kifizetési összeg",
  "注：最低提现金额多少元": "Megjegyzés: Mi a minimum kifizetési összeg jüanban?",
  "请选择状态": "Kérem válasszon állapotot",
  "提现方式": "Kifizetés módja",
  "请选择提现方式": "Kérem válasszon kifizetési módot",
  "微信": "WeChat",
  "支付宝": "Alipay",
  "银行卡": "Bankkártya",
  "请输入用户ID": "Kérem adja meg a felhasználó azonosítóját",
  "请输入昵称/姓名/手机号": "Kérem adja meg becenévét/nevét/telefonszámát",
  "提现信息": "Kifizetési információ",
  "支付宝名称": "Alipay név",
  "支付宝账号": "Alipay fiók",
  "银行名称": "Bank neve",
  "开户名": "Számlatulajdonos neve",
  "银行卡号": "Bankkártyaszám",
  "申请时间": "Kérelem ideje",
  "审核时间": "Ellenőrzés ideje",
  "微信付款": "WeChat fizetés",
  "该操作 将使用微信支付企业付款到零钱功能，确定打款吗？": "Ez az ügylet a WeChat vállalati fizetés funkcióját használja a pénz küldésére a pénztárcában. Biztosan folytatja?",
  "添加充值套餐": "Töltési csomag hozzáadása",
  "套餐名称": "Csomag neve",
  "请输入套餐名称": "Kérem adja meg a csomag nevét",
  "请输入支付金额": "Kérem adja meg a fizetendő összeget",
  "请输入赠送金额": "Kérem adja meg az ajándék összegét",
  "请输入到账金额": "Kérem adja meg a ténylegesen kapott összeget",
  "请输入排序": "Kérem adja meg a sorrendet",
  "用户ID": "Felhasználó azonosító",
  "会员卡管理": "Tagságikártya kezelése",
  "领取记录": "Beszerzési napló",
  "删除记录": "Törölés napló",
  "请输入关键词": "Kérem adjon meg kulcsszavakat",
  "过期": "Lejárt",
  "有效": "Érvényes",
  "客户信息": "Ügyfél adatok",
  "会员卡名称": "Tagságikártya név",
  "有效期": "Érvényességi idő",
  "折": "Kedvezmény",
  "领取时间": "Beszerzés ideje",
  "延期": "Meghosszabbítás",
  "撤销": "Visszavonás",
  "添加会员卡": "Tagságikártya hozzáadása",
  "启用": "Engedélyezés",
  "关闭": "Letiltás",
  "月": "Hónap",
  "永久有效": "Végtelen időre érvényes",
  "领取数量": "Beszerzési mennyiség",
  "发卡": "Kártya kibocsátás",
  "领取设置": "Beszerzés beállítások",
  "请检查必填项是否填写完整": "Kérem ellenőrizze, hogy az kötelező mezők kitöltve vannak-e",
  "领取人数": "Beszerzők száma",
  "删除时间": "Törlés ideje",
  "请填写有效期": "Kérem adja meg az érvényességi időt",
  "有效期限（月），0为永久有效": "Érvényességi idő (hónap), 0 az örök érvényességhez",
  "请填写价格": "Kérem adjon meg árat",
  "用户购买会员卡需要支付的金额，0为用户免费领取": "A felhasználók a tagságikártyáért fizetendő összeg, 0 az ingyenes beszerzéshez",
  "使用须知": "Használati utasítások",
  "请填写使用须知": "Kérem adja meg a használati utasításokat",
  "请填写会员卡名称": "Kérem adja meg a tagságikártya nevét",
  "卡片类型": "Kártya típus",
  "卡片样式": "Kártya stílus",
  "请填写排序": "Kérem adjon meg egy sorrendet",
  "会员权益": "Tagsági jogok",
  "无折扣": "Nincs kedvezmény",
  "请填写折扣": "Kérem adja meg a kedvezményt",
  "开卡赠送": "Ajándék a kártya kibocsátásakor",
  "优惠券": "Kupon",
  "请填写积分数量": "Kérem adja meg a pontok mennyiségét",
  "请填写余额数量": "Kérem adja meg az egyenleg mennyiségét",
  "请填写优惠券": "Kérem adja meg a kupont",
  "添加优惠券": "Kupon hozzáadása",
  "券名称": "Kupon név",
  "每人领取数量": "Mindenki számára beszerzési mennyiség",
  "选择优惠券弹出层": "Kupon kiválasztása felugró ablak",
  "您已经选择了十五张优惠券，若要更换请删除其他优惠券！": "Ön már kiválasztotta az öt kuponból az összeset, ha cserélni szeretne, kérjük törölje a többit!",
  "产品编码": "Termék kód",
  "请填写产品编码": "Kérem adja meg a termék kódját",
  "产品划线价": "Termék listaára",
  "请填写产品划线价": "Kérem adja meg a termék listaárát",
  "商品重量": "Termék súlya",
  "请填写商品重量": "Kérem adja meg a termék súlyát",
  "批量设置": "Csoportos beállítások",
  "划线价": "Listaár",
  "重量": "Súly",
  "应用": "Alkalmazás",
  "规格图片": "Leírás kép",
  "规格值": "Leírás érték",
  "请输入规格值": "Kérem adja meg a leírási értéket",
  "请填写规则名或规则值": "Kérem adja meg a szabály nevét vagy értékét",
  "规格值不能为空": "A leírási érték nem lehet üres",
  "卡名称": "Kártya név",
  "卡ID": "Kártya azonosító",
  "无": "Nincs",
  "选择会员": "Tagság kiválasztása",
  "恭喜你，发卡成功": "Gratulálok, a kártya sikeresen kiadva",
  "副卡数": "Kiegészítő kártyák száma",
  "张": "darab",
  "选择日期": "Dátum kiválasztása",
  "签到设置": "Bejelentkezés beállítások",
  "签到记录": "Bejelentkezési napló",
  "是否开启签到有礼": "Ajándékozás a bejelentkezésért engedélyezve",
  "每日签到固定奖励": "Naponta fix jutalom a bejelentkezésért",
  "每日签到送": "Napi bejelentkezési jutalom",
  "递增奖励": "Növekvő jutalom",
  "有": "Van",
  "第二天起递增奖励": "Növekvő jutalom a második naptól",
  "第": "Nap",
  "天起不再递增": "Az utolsó naptól nem lesz növekedés",
  "连续签到额外奖励 （达到额外奖励最大天数时，继续签到不会再获得额外奖励，断签后重新开始计算）": "További jutalom a folyamatos bejelentkezésekért (Ha elérted a maximális további jutalom napjait, akkor további bejelentkezésért nem kapsz további jutalmat; a megszakítás után a számláló visszaáll)",
  "额外奖励": "További jutalom",
  "连续签到": "Folyamatos bejelentkezés",
  "请输入连续签到天数": "Kérem adja meg a folyamatos bejelentkezések számát",
  "积分奖励": "Pontjutalom",
  "送": "ajándékoz",
  "请输入连续签到天数的积分": "Kérem adjon meg pontokat a folyamatos bejelentkezésekért",
  "规则": "Szabályok",
  "规则说明": "Szabályok leírása",
  "请添加至少一项额外奖励！": "Kérem adjon hozzá legalább egy további jutalmat!",
  "天数不能为空！": "A napok száma nem lehet üres!",
  "请输入连续签到积分数！": "Kérem adja meg a folyamatos bejelentkezésért járó pontokat!",
  "每日签到送积分有误": "Hibás pontok a napi bejelentkezésért",
  "请输入第二天起递增积分数": "Kérem adja meg a második naptól növekedő pontokat",
  "请输入第几天不再递增": "Kérem adja meg a növekedés leállításának napját",
  "恭喜你，保存成功": "Gratulálok, sikeres mentés",
  "连续签到天数": "Folyamatos Bejelentkezés Napjai",
  "不限": "Korlátlan",
  "签到时间": "Bejelentkezés Időpontja",
  "时间": "Idő",
  "请输入用户昵称": "Kérem adja meg a felhasználó becenevét",
  "签到日期": "Bejelentkezés Dátuma",
  "活动奖品": "Tevékenység Jutalmak",
  "取号记录": "Sorszám Lekérési Nyilvántartás",
  "桌号管理": "Asztalkezelés",
  "取号设置": "Sorszám Lefoglalás Beállítások",
  "请输入手机号": "Kérem adja meg a telefonszámot",
  "待叫号": "Várakozó Hívás",
  "已入座": "Beszállt",
  "已过号": "Kihagyva",
  "已取消": "Törölve",
  "就餐号": "Étkezési Szám",
  "就餐人数": "Vendégek Száma",
  "桌位名称": "Asztal Neve",
  "取号时间": "Sorszám Foglalás Ideje",
  "待取号": "Sorszám Foglalásra Vár",
  "是否开启打印": "Nyomtatás Engedélyezése",
  "须知": "Tudnivalók",
  "请输入须知": "Kérem adja meg a tudnivalókat",
  "商家说明": "Kereskedő Leírása",
  "请输入商家说明": "Kérem adja meg a kereskedő leírását",
  "取号规则": "Sorszám Lefoglalási Szabályok",
  "等待时间": "Várakozási Idő",
  "人数最小值": "Legalacsonyabb Személyek Száma",
  "人数最大值": "Legnagyobb Személyek Száma",
  "等待时间(分钟)": "Várakozási Idő (percekben)",
  "请输入桌位名称": "Kérem adja meg az asztal nevét",
  "请输入人数最小值": "Kérem adja meg a legalacsonyabb személyek számát",
  "请输入人数最大值": "Kérem adja meg a legnagyobb személyek számát",
  "请输入等待时间": "Kérem adja meg a várakozási időt",
  "商品设置": "Termék Beállítások",
  "兑换记录": "Csere Nyilvántartások",
  "活动名称": "Tevékenység Neve",
  "请输入活动名称": "Kérem adja meg a tevékenység nevét",
  "活动列表": "Tevékenység Lista",
  "添加活动": "Tevékenység Hozzáadása",
  "活动价格": "Tevékenység Ára",
  "发放数量": "Kibocsátás Mennyisége",
  "参与人数": "Résztvevők Száma",
  "终止": "Lezárás",
  "购买记录": "Vásárlási Nyilvántartások",
  "新增活动会场": "Új Tevékenység Helyszín Hozzáadása",
  "活动标题": "Tevékenység Címe",
  "请输入活动标题": "Kérem adja meg a tevékenység címét",
  "活动日期": "Tevékenység Dátuma",
  "礼包设置": "Ajándék Csomag Beállítások",
  "优惠券id": "Kupon Azonosító",
  "购买设置": "Vásárlási Beállítások",
  "购买金额": "Vásárlási Összeg",
  "会员购买等级": "Tagság Vásárlási Szintje",
  "指定等级": "Kijelölt Szint",
  "购买次数": "Vásárlás Gyakorisága",
  "限购": "Vásárlási Korlátozás",
  "每人限购": "Mindenkit érintő Vásárlási Korlátozás",
  "次": "Szer",
  "发放设置": "Kibocsátás Beállítások",
  "请输入发放数量": "Kérem adja meg a kibocsátás mennyiségét",
  "返回": "Vissza",
  "请勿重复添加": "Kérem ne ismételje meg a hozzáadást",
  "至少选择一个优惠券": "Kérem válasszon legalább egy kupont",
  "新增活动": "Új Tevékenység Hozzáadása",
  "券包设置": "Kupon Csomag Beállítások",
  "下载推广码": "Promóciós Kód Letöltése",
  "下载类型": "Letöltés Típusa",
  "使用该功能前，需前往小程序后台，在“设置”-“接口设置”-“公众号关注组件”中设置要展示的公众号。注：设置的公众号需与小程序主体一致": "Mielőtt használja ezt a funkciót, lépjen az alkalmazás háttérbe, a “Beállítások”-on belül menjen a “Interface Beállítások”-“Közönség Figyelmeztető Elem” részre válassza ki a megjelenítésre szánt közönség figyelmeztető elemet. Jegyzet: Az igazított közönség figyelmeztető elemnek megegyeznie kell az app fő célpontjával",
  "去配置": "Menj a Konfigurációhoz",
  "若没有配置公众号，功能将不生效": "Ha nincs konfigurálva közönség figyelmeztető elem, a funkció nem fog működni",
  "在一个小程序的生命周期内，只有从以下场景进入小程序，才具有展示引导关注公众号的能力": "Az app teljes élettartama alatt csak az alábbi helyszíneken belépve lesz képes megjeleníteni a közönség figyelmeztető elemet az app figyelmes figyeléséhez",
  "当小程序从扫小程序码打开时": "Ha az alkalmazás kódskenneléssel nyílik meg",
  "当从其他小程序返回小程序时，若小程序之前未被销毁，则该组件保持上一次打开小程序时的状态": "Amikor az app egy másik appból tér vissza, ha az app korábban nem volt törölve, az összetevő megőrzi az utolsó app nyitásakor állapotát",
  "公众号关注": "Közönség Figyelmeztetés",
  "新客设置": "Új Ügyfél Beállításai",
  "是否开启活动": "Van-e aktív tevékenység?",
  "活动时间": "Tevékenység Időszak",
  "背景图": "Háttérkép",
  "赠送优惠券": "Kupon Ajándékozás",
  "请选择优惠券": "Kérem válasszon kupont",
  "赠送积分": "Pont Ajándékozás",
  "请输入赠送积分": "Kérem adja meg az ajándékozni kívánt pontokat",
  "直播同步": "Élő Adás Szinkronizálás",
  "同步直播": "Élő Adás Szinkronizálása",
  "请输入直播间名称/主播昵称": "Kérem adja meg az élő adás terem nevét/vezetéknevét",
  "直播间ID": "Élő adás Terem Azonosító",
  "直播间名称": "Élő adás Terem Neve",
  "主播昵称": "Vezetéknev",
  "直播开始时间": "Élő Adás Kezdési Időpontja",
  "直播结束时间": "Élő Adás Vége",
  "直播间状态": "Élő Adás Terem Állapota",
  "置顶": "Fenttartás",
  "未置顶": "Nem Fenttartott",
  "已置顶": "Fenttartott",
  "设为置顶": "Fenttartás Beállítása",
  "取消置顶": "Fenttartás Mégse",
  "直播中": "Élő",
  "未开始": "Nem Kezdődött",
  "已结束": "Bevégzett",
  "禁播": "Sugárazás Tilos",
  "暂停": "Szünet",
  "异常": "Szokatlan",
  "已过期": "Lejárt",
  "置顶成功": "Fenttartás Sikeres",
  "邀请活动": "Meghívó Tevékenység",
  "个人中心图片": "Személyes Központ Kép",
  "请输入用户昵称/手机号": "Kérem adja meg a felhasználó becenevét/telefonszámát",
  "邀请人": "Meghívó",
  "被邀请人": "Meghívott",
  "参加时间": "Résztvevő Ideje",
  "个人中心显示": "Személyes Központ Megjelenítése",
  "参与记录": "Résztvétei Nyilvántartások",
  "礼品记录": "Ajándék Nyilvántartás",
  "推广二维码": "Két Dimenziós Kód Terjesztése",
  "编辑活动会场": "Tevékenység Helyszín Szerkesztése",
  "请输入分享标题": "Kérem adja meg a megosztási címet",
  "请输入分享内容": "Kérem adja meg a megosztási tartalmat",
  "分享内容": "Megosztási Tartalom",
  "分享图": "Megosztás Képe",
  "个人中心状态": "Személyes Központ Állapota",
  "邀请成功的条件": "Sikeres Meghívás Feltételei",
  "邀请成为会员": "Meghívás Tagságra",
  "邀请成为会员且消费": "Meghívás Tagságra és Vásárlásra",
  "礼品设置": "Ajándék Beállítások",
  "奖项": "Díj",
  "每邀请": "Minden Meghívásra",
  "人获得礼品": "Személy Kapjon Ajándékot",
  "添加奖励项": "Jutalmi Tétel Hozzáadása",
  "请上传背景图": "Kérem töltsön fel háttérképet",
  "请上传分享图": "Kérem töltsön fel megosztási képet",
  "请添加奖项": "Kérem adjon hozzá egy díjat",
  "开启首页推送": "Főoldali Értesítések Engedélyezése",
  "建议换活动，此名称更换，商城首页弹窗根据此名称不同来弹窗": "Javasolt tevékenység csere, ennek a névnek a változtatása alapján módosul a kereskedelmi központnyitó oldali ablakok megjelenése",
  "类型": "Típus",
  "图文": "Kép Szöveges",
  "纯图": "Csak Kép",
  "领取优惠券": "Kupon Átvétele",
  "请输入标题": "Kérem adja meg a címet",
  "弹窗图片": "Felugró Kép",
  "图片为2M以内大小，格式限png，jpg格式": "A kép mérete legfeljebb 2MB lehet, és csak PNG, JPG formátumban elfogadott",
  "建议尺寸": "Ajánlott Méret",
  "按钮文案": "Gomb Szöveg",
  "简介说明": "Rövid Leírás",
  "请输入说明": "Írja le az utasításokat",
  "点击选择你要链接的位置": "Válassza ki a kapcsolódási helyet",
  "跳转地址": "Ugrás Címe",
  "最多可以添加三张": "Maximum három kép hozzáadható",
  "最多添加3张优惠券": "Legfeljebb 3 kupont adhat hozzá",
  "标题不能为空": "A cím nem lehet üres",
  "请选择跳转链接": "Válasszon ugrási linket",
  "请选择优惠卷": "Válasszon kupont",
  "请上传图片": "Kérem töltsön fel képet",
  "团购订单": "Csapat Vásárlási Rendelések",
  "团购管理": "Csapat Vásárlás Kezelése",
  "团购设置": "Csapat Vásárlási Beállítások",
  "订单设置": "Rendelés Beállítások",
  "未支付订单": "Kifizetetlen Rendelések",
  "请输入关闭时间": "Kérem adja meg a bezárás idejét",
  "分钟后自动关闭": "Automatikusan bezárás percenként",
  "团购保障": "Csapat Vásárlási Biztosítás",
  "使用门店": "Áruház Használata",
  "待付款": "Fizetés Folyamatban",
  "待使用": "Használatra Várakozik",
  "已退款": "Visszatérítve",
  "使用门店名称": "Áruház Használat Neve",
  "门店联系人": "Áruház Kapcsolattartó",
  "门店电话": "Áruház Telefonszáma",
  "团购信息": "Csapat Vásárlás Információ",
  "券码信息": "Kuponkód Információ",
  "核销券码": "Kuponkód Ellenőrzése",
  "添加团购": "Csapat Vásárlás Hozzáadása",
  "团购名称": "Csapat Vásárlás Neve",
  "销售价格": "Értékesítési Ár",
  "虚拟销量": "Virtuális Eladási Mennyiség",
  "部分": "Részvény",
  "基础设置": "Alap Beállítások",
  "购买须知": "Vásárlási Utasítások",
  "团购详情": "Csapat Vásárlás Részletek",
  "团购须知": "Csapat Vásárlási Utasítások",
  "请输入团购名称": "Kérem adja meg a csapat vásárlás nevét",
  "到期类型": "Lejárati Típus",
  "购买后生效": "Vásárlást követő Érvényes",
  "固定时间": "Rögzített Időpont",
  "有效天数": "Érvényességi Napok Száma",
  "请输入有效天数": "Kérem adja meg az érvényességi napok számát",
  "有效时间": "Érvényességi Idő",
  "请输入有效时间": "Kérem adja meg az érvényességi időt",
  "团购图片": "Csapat Vásárlás Kép",
  "请上传团购图片": "Kérem töltsön fel csapat vásárlás képet",
  "请输入划线价格": "Kérem adja meg a kiárusított árat",
  "请输入销售价格": "Kérjük adja meg az eladási árat",
  "请输入虚拟销量": "Kérjük adja meg a virtuális értékesítési mennyiséget",
  "适用门店": "Alkalmazható üzletek",
  "请选择门店": "Válassza ki az üzletet",
  "团购状态": "Csoportos vásárlás állapota",
  "每日限购数量": "Napi vásárlási limit",
  "每个会员每日购买的最大数量，0为不限购": "Az egy tagra naponta eső maximális mennyiség, 0 az általános",
  "商家名称": "Kereskedő neve",
  "平台": "Platform",
  "满类型": "Teljesítés típusa",
  "满额": "Küszöbérték",
  "满件数": "Teljesítés mennyisége",
  "满值": "Teljesítés értéke",
  "减类型": "Csökkentés típusa",
  "减金额": "Csökkentés összege",
  "打折": "Kedvezmény",
  "减值": "Csökkentés értéke",
  "编辑活动": "Aktivitás szerkesztése",
  "满金额": "Teljes összeg",
  "请输入满值": "Kérjük adja meg a teljesítés értékét",
  "如果是打折，填写80，表示打8折": "Ha kedvezmény, írjon be 80-at, ami 20% kedvezményt jelent",
  "满额免配送费设置": "Ingyenes szállítás teljesítésért",
  "是否开启满额免配送费": "Engedélyezi az ingyenes szállítást teljesítésért",
  "单笔订单满": "Egyszeri rendelés összértéke",
  "如果开启满额免配送费，设置0为全场免配送费": "Ha az ingyenes szállítás engedélyezve van, állítsa be 0-ra az egész rendelés számára",
  "入驻申请": "Belépési kérelem",
  "配送员": "Szállítómunkás",
  "配送订单": "Szállítási rendelések",
  "提现申请": "Pénzfelvételi kérelem",
  "配送设置": "Szállítási beállítások",
  "退出申请": "Kilépési kérelem",
  "正常": "Normál",
  "押金": "Letét",
  "累计佣金": "Összesített jutalék",
  "可提现佣金": "Kivehető jutalék",
  "已提现佣金": "Kivehető jutalék összege",
  "提现明细": "Pénzfelvételi részletek",
  "申请条件": "Kérelem feltételei",
  "结算": "Elszámolás",
  "是否开启押金支付": "Az előleges fizetés engedélyezve van-e",
  "是否审核": "Ellenőrzés szükséges",
  "需后台审核": "Háttérellenőrzés szükséges",
  "无需审核": "Nem szükséges ellenőrizni",
  "产品列表弹出层": "Terméklista felugró ablaka",
  "已选择该商品": "A termék már kiválasztva",
  "注：如使用微信支付，则需申请微信支付企业付款到零钱功能": "Megjegyzés: Ha a WeChat Pay-t használja, kérjen WeChat Céges fizetési funkciót a zsebpénzébe",
  "微信提现方式": "WeChat pénzfelvételi mód",
  "微信提现到零钱": "Pénzfelvétel a WeChat zsebpénzre",
  "商家转账到零钱": "Kereskedő átutalása a zsebpénzre",
  "注：根据实际产品开通情况选择": "Válasszon az aktuális termékaktiváció szerint",
  "最低提现额度": "Minimum pénzfelvétel összege",
  "佣金结算时间": "Jutalék elszámolási ideje",
  "注：当订单完成n小时后，该订单的配送佣金才会结álani到配送员余额，如果设置为0小时，则订单完成时就结álani": "Megjegyzés: A szállítási jutalékokat a rendelés befejezése után n órával számolják el a szállítót egyenlegére. 0 esetén azonnali elszámolás a rendelés befejezésénél",
  "请至少选择一种提现方式": "Kérjük válasszon legalább egy pénzfelvételi módot",
  "佣金结算": "Jutalék elszámolás",
  "是否结算佣金": "Elszámolja-e a jutalékot",
  "已结算": "Elszámolt",
  "未结算": "Nem számolták el",
  "送达状态": "Kiszállítás állapota",
  "查看详情": "Részletek megtekintése",
  "该操作将使用微信支付企业付款到零钱功能，确定打款吗？": "Ez a művelet a WeChat Enterprise Payment funkciót fogja használni a pénz átutalására a zsebpénzére. Biztos benne, hogy végrehajtja a tranzakciót?",
  "身份证号": "Személyazonosító szám",
  "待交押金": "Fizetendő letét",
  "审核方式": "Ellenőrzési mód",
  "查看": "Megtekintés",
  "配送员审核": "Szállítómunkás ellenőrzése",
  "添加外卖商品": "Hozzáadni elvitelre szánt termékeket",
  "序号": "Sorszám",
  "活动折扣": "Akciós kedvezmény",
  "活动库存": "Akciós készlet",
  "添加店内商品": "Helyszíni termékek hozzáadása",
  "优惠券列表": "Kuponlista",
  "发送优惠券": "Küldje el a kuponokat",
  "发送对象": "Küldés címzettjei",
  "全站会员": "Összes tagság",
  "指定会员": "Kijelölt tagság",
  "选择会员等级": "Válassza ki a tagság szintjét",
  "发送的优惠券会员领取已达到限制数量，将不再发送给该会员": "A kínált kupont a tag már elérte a maximális számot, nem lesz további kiküldés",
  "发送成功": "Küldés sikeres",
  "优惠券ID": "Kuponazonosító",
  "优惠券名称": "Kupon neve",
  "优惠券类型": "Kupon típusa",
  "最低消费金额": "Minimális vásárlási összeg",
  "优惠方式": "Kedvezmény módja",
  "立减": "Közvetlen levonás",
  "打": "Kedvezmény",
  "领取": "Felvehető",
  "天内有效": "Napon belül érvényes",
  "发放总数量": "Összesített kiosztási mennyiség",
  "不限制": "Korlátozás nélkül",
  "已领取数量": "Felvehető mennyiség",
  "修改优惠券": "Kupon módosítása",
  "请输入优惠券名称": "Kérjük adja meg a kupon nevét",
  "例如：满100减10": "Például: 100€ vásárlásból 10€ kedvezmény",
  "优惠券颜色": "Kupon színe",
  "蓝色": "Kék",
  "红色": "Piros",
  "紫色": "Lila",
  "黄色": "Sárga",
  "满减券": "Teljesítéses levonásos kupon",
  "折扣券": "Kedvezményes kupon",
  "减免金额": "Levonás összege",
  "请输入减免金额": "Kérjük adja meg a levonási összeget",
  "折扣率": "Kedvezmény mértéke",
  "请输入折扣率": "Kérjük adja meg a kedvezmény mértékét",
  "折扣率范围0-10，9.5代表9.5折，0代表不折扣": "A kedvezmény mértéke 0 és 10 közötti érték. Például: 9.5 a 10% kedvezményt, 0 pedig nincs kedvezmény",
  "请输入最低消费金额": "Kérjük adja meg a minimális vásárlási összeget",
  "后生效": "Majd hatályba lép",
  "请输入发放总数量": "Kérjük adja meg az összesített kiosztási mennyiséget",
  "限制领取的优惠券数量，-1为不限制": "Korlátozza a kuponok felvételének számát, -1 a korlátlan",
  "是否显示在领券中心": "Megjelenjen-e a kuponközpontban?",
  "新用户首次进入小程序的时候才会显示如图所示的弹窗提示，只显示一次": "Az új felhasználók az első belépéskor az ilyen típusú felugró ablakot fogják látni, és csak egyszer jelenik meg",
  "引导收藏": "Gyűjtőbe való irányítás",
  "编辑类型": "Szerkesztés típusa",
  "生日设置": "Születésnapi beállítások",
  "手机短信": "Mobil SMS",
  "分销商用户": "Értékesítési partner felhasználó",
  "分销订单": "Értékesítési partner rendelések",
  "分销海报": "Értékesítési partner plakátok",
  "推荐人": "Ajánló",
  "下级用户": "Alsóbb szintű felhasználók",
  "一级": "Elsődleges",
  "二级": "Másodlagos",
  "三级": "Harmadlagos",
  "成为时间": "Csatlakozás ideje",
  "下级": "Alsóbb szint",
  "加入时间": "Csatlakozás ideje",
  "分销商条件": "Értékesítési partner feltételek",
  "佣金设置": "Jutalékbeállítás",
  "自定义文字": "Egyedi szöveg",
  "申请协议": "Kérelem megállapodás",
  "页面背景图": "Oldal háttérkép",
  "分销中心页面": "Értékesítési központ oldala",
  "页面标题": "Oldal címe",
  "分销中心": "Értékesítési központ",
  "非分销商提示": "Nem értékesítési partner figyelmeztetés",
  "您还不是分销商，请先提交申请": "Még nem értékesítési partner, kérjük először küldje be a kérelmet",
  "申请成为分销商": "Értékesítési partnerként való jelentkezés",
  "立即加入": "Csatlakozás most",
  "可提现": "Kivehető",
  "待提现佣金": "Kivehető jutalék elbírálás alatt",
  "待提现": "Kérelem alatt",
  "已提现金额": "Kifizetett összeg",
  "去提现": "Pénzfelvétel",
  "申请成为分销商页面": "Értékesítési partner jelentkezési oldal",
  "请填写申请信息": "Kérjük töltse ki a jelentkezési adatokat",
  "分销商申请协议": "Értékesítési partneri jelentkezési megállapodás",
  "申请成为经销商": "Jelentkezés értékesítési partnerként",
  "审核中提示信息": "Ellenőrzési folyamatban",
  "您的申请已受理，正在进行信息核验，请耐心等待。": "A kérelmét elfogadtuk, az adatok ellenőrzése folyamatban van, kérjük legyen türelemmel.",
  "去商城逛逛": "Vásároljon a boltban",
  "分销订单页面": "Értékesítési partner rendelése oldal",
  "我的团队页面": "Saját csapatom oldala",
  "我的团队": "Csapatom",
  "团队总人数": "Teljes csapattagok száma",
  "一级团队": "Elsődleges csapat",
  "二级团队": "Másodlagos csapat",
  "三级团队": "Harmadlagos csapat",
  "提现明细页面": "Kifizetési részletek oldala",
  "审核中": "Ellenőrzés alatt",
  "申请提现页面": "Kifizetési kérelem oldal",
  "申请提现": "Kifizetési kérelem beküldése",
  "请输入要提取的金额": "Kérjük adja meg a kívánt kifizetés összegét",
  "最低提现佣金": "Minimális kifizetési jutalék",
  "提交申请": "Kérelem beküldése",
  "佣金结算天数": "Jutalék elszámolási napok",
  "注：当订单完成n天后，该订单的分销佣金才会结算到分销商余额，如果设置为0天,则订单完成时就结算": "Megjegyzés: A befejezett rendelés jutaléka n nap után kerül elszámolásra a terjesztő egyenlegére. Ha 0 napra van állítva, akkor a rendelés befejezésekor kerül elszámolásra",
  "成为分销商条件": "Terjesztői jogosultságok",
  "购买指定商品成为分销商": "Terjesztővé válás a megadott termék(ek) megvásárlásával",
  "购买指定商品付款后自动成为分销商，无需后台审核": "Terjesztővé automatikusan válni a megadott termék(ek) vásárlása után, háttér ellenőrzés nélkül",
  "选择商品": "Termékek kiválasztása",
  "成为下线条件": "Alsóbb szintű feltételek",
  "首次点击分享链接": "Az első kattintás a megosztott linkre",
  "一级佣金比例": "Elsődleges jutalékráta",
  "佣金比例范围 0% - 100%": "Jutalékráta tartomány 0% - 100%",
  "二级佣金比例": "Másodlagos jutalékráta",
  "三级佣金比例": "Harmadlagos jutalékráta",
  "是否开启分销功能": "Terjesztési funkció engedélyezése",
  "分销层级": "Terjesztési szintek",
  "一级分销": "Elsődleges terjesztés",
  "二级分销": "Másodlagos terjesztés",
  "三级分销": "Harmadlagos terjesztés",
  "分销商内购": "Terjesztő saját vásárlása",
  "如开启，分销商自己购买商品，获得一级佣金": "Ha engedélyezve van, a terjesztő saját vásárlásai esetén elsődleges jutalékot kap",
  "分销中心首页": "Terjesztési központ kezdőlap",
  "尺寸：宽750像素 高度227像素": "Méretek: Szélesség 750 képpont, Magasság 227 képpont",
  "申请成为分销商页": "Terjesztővé válás kérelmező oldal",
  "申请提现页": "Kifizetési kérelem oldal",
  "分销海报设置": "Terjesztési plakát beállítások",
  "海报背景图": "Plakát háttérkép",
  "尺寸：宽750像素 高大于(等于)1200像素": "Méretek: Szélesség 750 képpont, Magasság nagyobb vagy egyenlő 1200 képpont",
  "头像宽度": "Profilkép szélessége",
  "头像样式": "Profilkép stílusa",
  "正方形": "Négyzet alakú",
  "圆形": "Kerek",
  "昵称字体大小": "Becenév betűmérete",
  "昵称字体颜色": "Becenév betűszíne",
  "小程序码宽度": "Mini programkód szélessége",
  "小程序码样式": "Mini programkód stílusa",
  "分销商": "Terjesztő",
  "一级分销商": "Elsődleges terjesztő",
  "用户": "Felhasználó",
  "分销佣金": "Terjesztési jutalék",
  "二级分销商": "Másodlagos terjesztő",
  "三级分销商": "Harmadlagos terjesztő",
  "分销商审核": "Terjesztő ellenőrzése",
  "积分明细": "Pontok részletei",
  "变动数量": "Mennyiség változások",
  "积分名称": "Pontok neve",
  "例": "Példa",
  "修改积分名称后，在买家端的所有页面里，看到的都是自定义的名称": "A pontok nevének megváltoztatása után a vásárlói oldalakon a megszokott neve látható lesz",
  "商家使用自定义的积分名称来做品牌运营。如京东把积分称为“京豆”，淘宝把积分称为“淘金币”": "A vállalkozások egyedi pontneveket használnak a márkázáshoz. Például a JD a pontokat 'JD babbal' nevezi, míg a Taobao azokat 'Kincsérméknek'",
  // =====================  营销工具end   ==========

  // =====================  数据统计 start   ==========
  "销售统计": "Értékesítési statisztika",
  "会员统计": "Tagsági statisztika",
  "订单概况": "Rendelés áttekintés",
  "商品概况": "Termék áttekintés",
  "今日": "Ma",
  "累积会员数": "Összes tagság",
  "新增会员数": "Új tagok",
  "成交会员数": "Tranzakciós tagok",
  "排行榜": "Ranglista",
  "用户消费榜": "Felhasználói kiadási rangsor",
  "积分排行榜": "Pontok rangsora",
  "邀请人排行榜": "Meghívó rangsor",
  "成交会员占比": "Tranzakciós tagok aránya",
  "今天": "Ma",
  "最近7天": "Elmúlt 7 nap",
  "最近30天": "Elmúlt 30 nap",
  "最近90天": "Elmúlt 90 nap",
  "最近180天": "Elmúlt 180 nap",
  "最近1年": "Elmúlt 1 év",
  "最近2年": "Elmúlt 2 év",
  "所有占比": "Teljes arány",
  "成交会员": "Tranzakciós tagok",
  "未成交会员": "Nem tranzakciós tagok",
  "新增会员": "Új tagok",
  "最近一周": "Elmúlt hét",
  "最近一个月": "Elmúlt hónap",
  "最近三个月": "Legutóbbi három hónap",
  "选择店铺": "Áruház kiválasztása",
  "查询日期": "Keresés dátuma",
  "近七天": "Elmúlt hét",
  "近十五天": "Elmúlt tizenöt nap",
  "自定义时间": "Egyedi időszak",
  "日期": "Dátum",
  "有效订单数": "Érvényes rendelések száma",
  "选择时间": "Időpont kiválasztása",
  "交易统计": "Tranzakciós statisztika",
  "订单数": "Rendelések száma",
  "客单价": "Átlagos rendelési érték",
  "付款订单": "Fizetett rendelések",
  "付款人数": "Fizető ügyfelek száma",
  "商品统计": "Termékstatisztika",
  "在售商品": "Elérhető termékek",
  "件": "Darab",
  "已付款商品": "Fizetett termékek",
  "销量TOP10": "Top 10 Eladás",
  "浏览TOP10": "Top 10 Megtekintés",
  "浏览": "Megtekintés",
  "排行类型": "Rangsor típusa",
  "商品总数": "Termékek teljes száma",
  "已上架商品": "Feltöltött termékek",
  "已下架商品": "Leemelt termékek",
  "商品导出": "Termékek exportálása",
  "商品总销量": "Termékek teljes értékesítése",
  "商品总销售额": "Termékek összes értékesítési összege",
  "资产总览": "Eszköz áttekintés",
  "财务对账": "Pénzügyi egyeztetés",
  "交易记录": "Tranzakciói nyilvántartás",
  "店铺结算": "Áruház kiegyenlítése",
  "待结算金额": "Kiegyenlítésre váró összeg",
  "已结算金额": "Kiegyenlített összeg",
  "交易概况": "Tranzakciós áttekintés",
  "外卖统计": "Elvitel statisztika",
  "店内统计": "Belső statisztika",
  "订单类型": "Rendelés típusa",
  "应收金额": "Várható összeg",
  "实付金额": "Ténylegesen kifizetett összeg",
  "账户概况": "Számla áttekintés",
  "订单编号": "Rendelésszám",
  "支付状态": "Fizetési állapot",
  "付款方式": "Fizetési mód",
  "订单费用": "Rendelés költsége",
  "优惠": "Kedvezmény",
  "商户实际收入": "Kereskedő tényleges bevétele",
  "商品ID": "Termékazonosító",
  "小计": "Részösszeg",
  "请输入提现金额": "Kérjük adja meg a kifizetés összegét",
  "请输入打款方式": "Kérjük adja meg a fizetési módot",
  "支付宝真实姓名": "Alipay valós név",
  "请输入支付宝真实姓名": "Kérjük adja meg az Alipay valós nevét",
  "开户行名称": "Bank neve",
  "银行开户名": "Banki számlatulajdonos neve",
  "真实姓名": "Valós név",
  "应付金额": "Fizetendő összeg",
  "实付总额": "Teljes kifizetett összeg",
  "商户": "Kereskedő",
  "结算金额": "Kiegyenlítési összeg",
  "店铺结算金额": "Áruházi kiegyenlítési összeg",
  "操作提示": "Műveleti tippek",
  "订单结算金额 = 店铺结算总金额(含运费)": "Rendelés kiegyenlítési összeg = Áruházi kiegyenlítési összeg (szállítási díjjal)",
  "店铺收入金额 = 店铺结算总金额 - 店铺退款金额": "Áruházi bevétel = Áruházi kiegyenlítési összeg - Áruházi visszatérítés összege",
  "订单日期": "Rendelés dátuma",
  "订单结算金额": "Rendelés kiegyenlítési összeg",
  "配送费金额": "Kiszállítási költség",
  "商品编码": "Termékkód",
  "可用余额": "Elérhető egyenleg",
  "提现概况": "Kifizetési áttekintés",
  "搜索": "Keresés",
  "支出": "Kiadás",
  "金额": "Összeg",
  "收支类型": "Bevétel és kiadás típus",
  "确认要退吗?": "Megerősíti a visszatérést?",
  "申请成功": "Kérelem sikeres",
  "门店总金额": "Összes áruházi összeg",
  "累计收入": "Kumulatív bevétel",
  "访客数": "Látogatók száma",
  "访问量": "Látogatási mennyiség",
  "店铺收藏数": "Áruház kedveltessége",
  "商品收藏数": "Termék kedveltessége",
  "访问数": "Látogatottság száma",
  "收藏数": "Kedveltesség száma",
  "数": "Szám",
  "待支付": "Fizetésre vár",
  "实际到账": "Ténylegesen érkező összeg",
  // =====================  数据统计 end   ==========

  // ==================== 设置 start ================
  "商城设置": "Áruház beállítások",
  "物流公司": "Logisztikai vállalat",
  "chatgpt设置": "ChatGPT beállítások",
  "消息设置": "Üzenet beállítások",
  "短信设置": "SMS beállítások",
  "上传设置": "Feltöltés beállítások",
  "清理缓存": "Gyorsítótár törlése",
  "网址后缀英文名称": "Angol név a webhely utótaghoz",
  "英文名称": "Angol név",
  "默认头像": "Alapértelmezett avatar",
  "英文名称必须只包含数字和英文字母": "Az angol névnek csak számokat és betűket kell tartalmaznia",
  "恭喜你，商城设置成功": "Gratulálok, az Áruház beállítások sikeresen alkalmazva",
  "表单数据不符合规则": "Az űrlapadatok nem felelnek meg a szabályoknak",
  "剩余额度": "Maradék limit",
  "余额不足时，智能客服、AI魔法创建、多语言翻译等功能将无法使用": "Ha az egyenleg nem elegendő, akkor az Intelligens Ügyfélszolgálat, AI varázslat, és Többnyelvű fordítás funkciók nem lesznek elérhetők",
  "使用明细": "Felhasználási részletek",
  "消费": "Kiadás",
  "额度": "Kvóta",
  "数据缓存": "Adat gyorsítótár",
  "恭喜你，清理成功": "Gratulálok, a takarítási folyamat sikeres",
  "管理员列表": "Adminisztrátor lista",
  "角色管理": "Szerepkör kezelés",
  "登录日志": "Bejelentkezési napló",
  "操作日志": "Műveleti napló",
  "添加管理员": "Adminisztrátor hozzáadása",
  "管理员ID": "Adminisztrátor azonosító",
  "用户名": "Felhasználónév",
  "所属角色": "Hozzárendelt szerepkör",
  "超级管理员": "Szuper adminisztrátor",
  "所属门店": "Hozzárendelt áruház",
  "门店状态": "Áruház állapota",
  "已删除": "Törölve",
  "未删除": "Nem törölve",
  "账号状态": "Számla állapota",
  "恭喜你，该管理员删除成功": "Gratulálok, az adminisztrátort sikeresen törölték",
  "请输入用户名": "Kérlek add meg a felhasználónevet",
  "修改管理员": "Adminisztrátor szerkesztése",
  "添加角色": "Szerep hozzáadása",
  "角色ID": "Szerep azonosítója",
  "角色名称": "Szerep neve",
  "恭喜你，该角色删除成功": "Gratulálok, a szerepet sikeresen törölték",
  "编辑角色": "Szerep szerkesztése",
  "请输入角色名称": "Kérlek add meg a szerep nevét",
  "权限列表": "Jogosultság lista",
  "请输入用户名和真实姓名": "Kérlek add meg a felhasználónevet és a valódi nevet",
  "登录状态": "Bejelentkezési állapot",
  "全部标记为已读": "Összes megjelölése olvasottként",
  "公告详情": "Hirdetmény részletei",
  "全部标记为已读消息吗?": "Összes üzenet megjelölése olvasottként?",
  "操作成功!": "Művelet sikeres!",
  "已取消操作": "Művelet megszakítva",
  "订单流程设置": "Rendelési folyamat beállítások",
  "已支付订单": "Kifizetett rendelések",
  "订单下单未付款，n分钟后自动关闭，设置0不自动关闭": "A rendelések leadása után, ha nem történik kifizetés, n perc után automatikusan bezár, az 0 érték azt jelenti, hogy nincs automatikus bezárás",
  "分钟后自动核销": "perc után automatikus jóváírás",
  "如果在期间未核销，系统自动完成核销，设置0不自动核销": "Ha a jóváírás nem történik meg az időn belül, a rendszer automatikusan jóváírja, az 0 érték azt jelenti, hogy nincs automatikus jóváírás",
  "积分商城订单流程设置": "Pontok beváltása Áruház Rendelési folyamat beállítások",
  "已发货订单": "Szállított rendelések",
  "天后自动核销": "nap után automatikus jóváírás",
  "不包括桌台订单": "asztali rendelések kivételével",
  "恭喜你，交易设置成功": "Gratulálok, a tranzakció beállítások sikeresen alkalmazva",
  // ==================== 设置 end ================
  // ==================== Layout start ===========
  "当前版本": "Jelenlegi verzió",
  "试用版": "Próbaverzió",
  "专业版": "Szakmai kiadás",
  "高级版": "Fejlett kiadás",
  "至尊版": "Felsőbbrendű kiadás",
  "到期日期": "Lejárati dátum",
  "永不过期": "Soha nem jár le",
  "欢迎您": "Isten hozott",
  "修改密码": "Jelszó megváltoztatása",
  "此操作将退出登录, 是否继续?": "Ez az operáció kijelentkeztet, szeretné folytatni?",
  "原始密码": "Eredeti jelszó",
  "新密码": "Új jelszó",
  "确认新密码": "Új jelszó megerősítése",
  "系统公告": "Rendszer bejelentés",
  "请至少选择一件产品商品！": "Kérjük válasszon legalább egy terméket!",
  "超链接设置": "Hiperhivatkozás beállítások",
  "图像预览": "Kép előnézet",
  "页面": "Oldal",
  "当前链接": "Jelenlegi hivatkozás",
  "暂无": "Nincs adat",
  "页面路径": "Oldal útvonal",
  "注意一": "Megjegyzés egy",
  "注意二": "Megjegyzés kettő",
  "注意三": "Megjegyzés három",
  "同一个小程序链接其他小程序，最多只能链接10个，超过将不生效": "Ugyanaz a mini-program más mini-programhoz linkelve legfeljebb 10 link lehet;ha ez túllépi a limitet, akkor nem lesz hatásos",
  "不能填写自身小程序appid": "Nem lehet kitölteni a saját mini program appid-jét",
  "小程序链接留空默认跳到小程序首页": "Ha a mini-program link üres, akkor alapértelmezetten a mini-program kezdőoldalára ugrik",
  "分类": "Kategória",
  "选择": "Kiválasztás",
  "签到": "Aláírás",
  "积分商城": "Pontok Áruháza",
  "秒杀": "Vásárlási roham",
  "拼团": "Csoportvásárlás",
  "砍价": "Árleszorítás",
  "领券中心": "Kupon Központ",
  "生日有礼": "Születésnapi ajándék",
  "链接的网页必须支持SSL ，链接必须以 https:// 开头，否则无法跳转": "A linkelt weboldalnak támogatnia kell az SSL-t, és https://-val kell kezdődnie, különben nem lehet átirányítani",
  "链接的域名必须是备案域名，否则无法跳转": "A linkelt domain névnek regisztrált domaint kell lennie, különben nem lehet átirányítani",
  "您的网站域名必须加到微信小程序公众平台的业务域名处,详细说明？": "Az Ön weboldalának domain nevét hozzá kell adni a WeChat Mini Program Nyilvános Platform üzleti domainjéhez, tudna több részletet megadni?",
  "选择文章列表": "Cikklista kiválasztása",
  "文章标题": "Cikk címe",
  "文章分类": "Cikk kategória",
  "选择规格": "Jellemzők kiválasztása",
  "产品/规格": "Termék/jellemzők",
  "已选": "Kiválasztva",
  "查看物流": "Logisztika megtekintése",
  "请输入收货人": "Kérjük adja meg a címzett nevét",
  "请输入收获电话": "Kérjük adja meg a címzett telefonszámát",
  "省": "Tartomány",
  "市": "Város",
  "区": "Kerület",
  "现金收款": "Készpénzes fizetés",
  "余额收款": "Egyenleg fizetés",
  "其他方式": "Egyéb módszerek",
  "请输入会员ID号查询会员，输入完毕后点击确认": "Kérjük adja meg a tagszámot a tag kereséséhez, majd kattintson az elfogadásra",
  "请输入会员ID": "Kérjük adja meg a tagszámot",
  "会员昵称": "Tag becenév",
  "余额总计": "Egyenleg összesen",
  "登录会员仅作为积分累计，无法享受其他优惠": "A belépett tagok csak pontokat gyűjthetnek, más kedvezmények nem vehetők igénybe",
  "取消收款": "Fizetés megszakítása",
  "收款": "Fizetés",
  "请输入会员手机号": "Kérjük adja meg a tag telefonszámát",
  "该用户不存在": "Ez a felhasználó nem létezik",
  "注册": "Regisztráció",
  "平台名称": "Platform név",
  "请输入平台名称": "Kérjük adja meg a platform nevét",
  "所在地区": "Elhelyezkedés",
  "请选择所在地区": "Kérjük válassza ki az elhelyezkedést",
  "平台账户名": "Platform fióknév",
  "请输入平台账户名": "Kérjük adja meg a platform fióknevet",
  "平台账户密码": "Platform fiókjelszó",
  "是否连锁": "Lánc üzlet?",
  "是": "Igen",
  "否": "Nem",
  "请输入您的地址": "Kérjük adja meg a címét",
  "请输入您的联系电话": "Kérjük adja meg a kapcsolati telefonszámát",
  "请输入您的联系邮箱": "Kérjük adja meg a kapcsolati email címét",
  "联系邮箱": "Kapcsolati email",
  "不能全是空格": "Nem lehet teljesen üres",
  "不能包含空格": "Nem tartalmazhat szóközöket",
  "长度不能小于6位": "A hossz nem lehet kisebb 6 karakternél",
  "请填写确认密码": "Kérjük adja meg az új jelszót újra",
  "确认密码不一致": "A jelszavak nem egyeznek",
  "联系电话和联系邮箱至少填写一个": "Kérjük legalább egy kapcsolati telefonszámot vagy email címet adjon meg",
  "注册成功,请前往登录": "Sikeres regisztráció, kérjük látogasson el a bejelentkezéshez",
  "清空": "Törlés",
  "确认": "Megerősítés",
  "限时免费": "Korlátozott idejű ingyenes",
  // ==================== Components end     =========

  // ==================== 其它  start  ================
  "菜品总量": "ételek összes mennyisége",
  "菜品排行榜": "ételek rangsora",
  "商家信息": "kereskedő adatai",
  "与店内营业时间相同": "ugyanaz, mint az üzlet nyitva tartási ideje",
  "菜品": "ételek",
  "菜品分类": "ételek kategorizálása",
  "通告": "értesítés",
  "商家店名": "kereskedés neve",
  "请输入商家店名": "kérjük, adja meg a kereskedés nevét",
  "温馨提示：选择后，请勿随意修改，以免造成门店菜品数据错乱": "Figyelem: Kérjük, ne változtassa meg véletlenül a kiválasztott elemet, hogy elkerülje az üzlet ételeinek adatainak zavart",
  "网址后缀设置": "URL végződés beállítása",
  "选填，设置后缀可替换下列网址末尾的数字id，方便记忆": "Opcionális: A végződés beállítása cserélheti az alábbi URL végét lévő számazonosítót a könnyebb megjegyzés érdekében",
  "网址设置": "URL beállítás",
  "手机网站二维码": "Mobil weboldal QR kód",
  "按菜品收费": "ételek ára alapján",
  "外卖菜品": "Házhozszállított ételek",
  "店内菜品": "üzletben kapható ételek",
  "菜品管理": "ételek kezelése",
  "菜品名称": "étel neve",
  "请输入菜品名称": "Kérjük, adja meg az étel nevét",
  "此菜品正在参加活动，不能修改规格": "Ez az étel részt vesz egy eseményen, nem lehet módosítani a specifikációkat",
  "通过人工智能技术，可以根据菜品名称自动填写菜品详细信息，如配料、卖点、口味等。": "Az emberi intelligencia technológia segítségével az ételek részletes információi automatikusan kitölthetők az étel neve alapján, például a hozzávalók, az eladási pontok, az ízek stb.",
  "请填写菜品详情": "Kérjük, adja meg az étel részleteit",
  "菜品详情": "étel részletei",
  "菜品图片": "étel kép",
  "请上传菜品图片": "Töltse fel az étel képét",
  "AI未识别到您的菜品图片": "Az AI nem azonosította az ételképet",
  "本菜品正在参加活动，不能删除规格！": "Ez az étel részt vesz egy eseményen, nem törölhető a specifikáció!",
  "菜品加料": "étel hozzávalói",
  "菜品状态": "étel állapota",
  "选择菜品状态": "Válassza ki az étel állapotát",
  "菜品排序": "étel sorrendje",
  "请填写菜品名称": "Kérjük, adja meg az étel nevét",
  "你选择菜品分类": "Ön választotta ki az ételek kategóriáját",
  "菜品卖点": "étel eladási pontjai",
  "菜品属性": "étel tulajdonságai",
  "菜品同步": "ételek szinkronizálása",
  "是否同步菜品至外卖": "ételek szinkronizálása házhozszállításhoz",
  "是否同步菜品至店内": "ételek szinkronizálása az üzletbe",
  "搜索菜品": "ételek keresése",
  "菜品原价": "étel eredeti ára",
  "菜品来源": "étel forrása",
  "菜品列表": "étel lista",
  "菜品销量": "étel értékesítési mennyisége",
  "通告管理": "értesítések kezelése",
  "添加通告": "értesítés hozzáadása",
  "通告ID": "értesítés ID-ja",
  "通告标题": "értesítés címe",
  "通告分类": "értesítés kategóriája",
  "通告排序": "értesítés sorrendje",
  "通告状态": "értesítés állapota",
  "通告内容": "értesítés tartalma",
  "编辑通告": "értesítés szerkesztése",
  "AI助理形象选择": "AI asszisztens megjelenésének kiválasztása",
  "菜品信息": "étel információ",
  "菜品总价": "ételek teljes ára",
  "请按实际店名填写，将显示在商家点餐网站上": "Kérjük, adja meg a valós üzlet nevét, amely megjelenik a kereskedő webhelyén",
  "首次添加桌位请先添加桌位类型": "Az első asztal hozzáadásához először adjon hozzá asztaltípust",
  "首次添加桌位请先添加区域": "Az első asztal hozzáadásához először adjon hozzá területet",
  "设置店内区域，如A区、B区、大厅、包厢等": "állítsa be az üzlet belső területét, például A terület, B terület, előcsarnok, dohányzó stb.",
  "设置桌位类型，如二人桌、四人桌、大桌、小桌等": "állítsa be az asztaltípust, például két személyes asztal, négy személyes asztal, nagy asztal, kis asztal stb.",
  "该账号用于登录收银台网站（可在“网址设置”页面找到收银台网址）": "Ez a fiók a pénztári webhelyre való bejelentkezéshez (a 'URL beállítások' oldalon található meg a pénztári webhely URL-je)",
  "该账号用于登录后厨网站（可在“网址设置”页面找到后厨网址）": "Ez a fiók a konyhai webhelyre való bejelentkezéshez (a 'URL beállítások' oldalon található meg a konyhai webhely URL-je)",
  "如无需设置税率可不填写": "Ha nem szükséges adókulcs beállítása, nem kell kitölteni",
  "打款信息": "Fizetési információk",
  "开户行": "Bank",
  "设置0不自动配送，下单后未配送，设置时间后自动操作配送": "Az 0 beállítása a manuális szállításra; a rendelést nem szállítják ki azonnal a rendelés után, az idő beállítása után automatikusan el lesz küldve",
  "菜品分组": "ételek csoportosítása",
  "自定义名称，仅用于商家自己区分分类，不会展示给顾客": "Egyedi név, csak a kereskedők számára kategóriák megkülönböztetésére, nem látszik a vásárlóknak",
  "手机网站编辑": "Mobil weboldal szerkesztése",
  "恢复初始默认页面": "Alapértelmezett kezdőlap visszaállítása",
  "通告为手机网站上展示的通知、公告、商家介绍等，“显示”状态时，该篇通告将展示在手机网站上": "Az értesítés az telefonos weboldalon megjelenített értesítés, hirdetés, kereskedő bemutatkozás stb.; amikor a 'Megjelenítés' állapotban van, az értesítés megjelenik a mobil weboldalon",
  "菜品重量": "étel súlya",
  "请填写菜品重量": "Kérjük, adja meg az étel súlyát",
  "菜品设置": "ételek beállítása",
  "已选择该菜品": "Kiválasztotta ezt az ételt",
  "注：当订单完成n小时后，该订单的配送佣金才会结算到配送员余额，如果设置为0小时，则订单完成时就结算": "Megjegyzés: A rendelés befejezése után n órával az adott rendelés szállítási jutalma csak akkor kerül elszámolásra a szállítóegyenlegre, ha 0 órára van beállítva, akkor azonnal a rendelés befejezésekor kerül elszámolásra",
  "添加外卖菜品": "Házhozszállított ételek hozzáadása",
  "添加店内菜品": "üzletben kapható ételek hozzáadása",
  "购买指定菜品成为分销商": "A megadott étel megvásárlásával viszonteladóvá válhat",
  "购买指定菜品付款后自动成为分销商，无需后台审核": "A megadott étel fizetése után automatikusan viszonteladóvá válik, nem szükséges adminisztrációs jóváhagyás",
  "选择菜品": "Válasszon ételt",
  "如开启，分销商自己购买菜品，获得一级佣金": "Ha engedélyezi, a viszonteladó saját maga vásárolja meg az ételeket, és első szintű jutalékot kap",
  "积分说明": "Pont magyarázat",
  "积分赠送": "Pont adományozás",
  "是否开启购物送积分": "Pontok adományozása vásárláskor",
  "积分赠送规则": "Pontadományozási szabályok",
  "如开启则订单完成后赠送用户积分": "Ha engedélyezi, a rendelés befejezése után pontokat ad az ügyfélnek",
  "订单确认收货已完成": "A rendelés átvétele megerősített, befejezett",
  "已完成订单超出后台设置的申请售后期限": "A befejezett rendelés meghaladja a háttérben beállított visszaküldési határidőt",
  "积分赠送比例": "Pontadományozási arány",
  "赠送比例请填写数字0~100；订单的运费不参与积分赠送": "Az ajándékozási aránynak 0 és 100 közötti számot kell megadni; a szállítási díj nem vesz részt a pontadományozásban",
  "订单付款金额(100.00€) * 积分赠送比例(100%) = 实际赠送的积分(100积分)": "Rendelés fizetési összege (100.00€) * Pontadományozási arány (100%) = Ténylegesen adományozott pontok (100 pont)",
  "菜品概况": "ételek áttekintése",
  "菜品统计": "ételek statisztikája",
  "在售菜品": "Kapható ételek",
  "已付款菜品": "Fizetett ételek",
  "菜品总数": "ételek összesen",
  "已上架菜品": "Feltett ételek",
  "已下架菜品": "Levetett ételek",
  "菜品导出": "ételek exportálása",
  "菜品总销量": "Összes értékesített ételek",
  "菜品总销售额": "Összes értékesítési összeg",
  "菜品ID": "étel azonosító",
  "菜品收藏数": "ételek kedvelése",
  "请至少选择一件产品菜品！": "Legalább válasszon ki egy termékételt!",
  "请输入收货电话": "Kérjük, adja meg a szállítási telefonszámot",
  "区域管理": "Regionális Menedzsment",
  "点餐管理系统": "Rendelési rendszer",
  "首页": "Kezdőlap",
  "余额支付": "Egyenleg fizetés",
  "线下支付(现金支付)": "Offline fizetés (készpénz)",
  "线下支付(自有微信支付)": "Offline fizetés (saját WeChat fizetés)",
  "线下支付(自有支付宝支付)": "Offline fizetés (saját Alipay fizetés)",
  "线下支付(POS刷卡支付)": "Offline fizetés (POS kártyás fizetés)",
  "待配送": "Szállítás várakozás",
  "配送中": "Szállítás alatt",
  "待接单": "Elfogadás várakozás",
  "待取货": "Átvétel várakozás",
  "已配送": "Szállítva",
  "已收货": "Átvett",
  "待收货": "Átvétel várakozás",
  "待取消": "Mégsemzés várakozás",
  "会员": "Tag",
  "商家": "Kereskedő",
  "供应商": "Beszállító",
  "分销": "Forgalmazás",
  "通知": "Értesítés",
  "已付款": "Fizetve",
  "用户下单": "Felhasználó rendelést adott",
  "收银台下单": "Pénztár rendelés",
  "扫码下单": "Kódolvasással rendelés",
  "团购下单": "Csoportos rendelés",
  "商城订单": "Bevásárlóközpont rendelés",
  "积分商城订单": "Pontrendszer rendelés",
  "余额充值订单": "Egyenlegfeltöltés rendelés",
  "购卡订单": "Kártyavásárlási rendelés",
  "券包订单": "Kuponcsomag rendelés",
  "配送员押金订单": "Szállítmányozó letét rendelés",
  "快递配送": "Expressz szállítás",
  "个人中心": "Személyes központ",
  "在地图中点击确认位置，坐标自动填入":"Kattintson a térképen a hely megerősítéséhez, és a koordináták automatikusan kitöltődnek.",
  "添加优惠券请前往'营销工具'—'插件中心'—'优惠券'页面":"Kupon hozzáadásához kérjük, látogasson el a 'Marketing' - 'Marketing eszközök' - 'Kupon' oldalra.",
  // ==================== 其它  end    ================

  ...huLocale
}


export default hu



// WEBPACK FOOTER //
// ./src/i18n/langs/hu.js